function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIls3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "2500px",
    height: "1979px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#231f20",
    d: "M 1105.5,284.5 C 1122.2,284.565 1129.7,292.898 1128,309.5C 1121.57,322.534 1111.73,326.034 1098.5,320C 1090.14,312.575 1088.31,303.742 1093,293.5C 1096.24,289.082 1100.4,286.082 1105.5,284.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4d95f",
    d: "M 1105.5,294.5 C 1116.16,293.328 1120.33,297.994 1118,308.5C 1110.99,315.687 1104.99,315.02 1100,306.5C 1098.87,301.089 1100.71,297.089 1105.5,294.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#242021",
    d: "M 858.5,316.5 C 881.338,314.498 900.172,322.164 915,339.5C 920.721,348.276 925.388,357.609 929,367.5C 951.128,420.084 972.962,472.751 994.5,525.5C 1254.83,525.667 1515.17,525.5 1775.5,525C 1780.83,522.333 1786.17,519.667 1791.5,517C 1758.17,491.667 1724.83,466.333 1691.5,441C 1692.5,439.333 1693.5,437.667 1694.5,436C 1695.83,435.333 1697.17,435.333 1698.5,436C 1735.41,453.038 1772.24,470.205 1809,487.5C 1809.15,445.494 1808.65,403.494 1807.5,361.5C 1809.79,361.756 1811.96,361.423 1814,360.5C 1824.25,401.085 1834.25,441.752 1844,482.5C 1875.5,456.333 1907,430.167 1938.5,404C 1939.76,403.018 1941.09,402.685 1942.5,403C 1943.83,404.333 1945.17,405.667 1946.5,407C 1920.64,440.024 1894.98,473.19 1869.5,506.5C 1910.44,515.213 1951.44,523.713 1992.5,532C 1991.58,534.041 1991.24,536.208 1991.5,538.5C 1958.18,539.579 1924.85,540.413 1891.5,541C 1904.7,553.862 1917.53,567.029 1930,580.5C 1934.67,597.833 1939.33,615.167 1944,632.5C 1944.5,643.495 1944.67,654.495 1944.5,665.5C 1975.17,665.333 2005.84,665.5 2036.5,666C 2059.27,667.295 2076.77,677.461 2089,696.5C 2094.21,705.13 2097.21,714.463 2098,724.5C 2098.67,857.5 2098.67,990.5 2098,1123.5C 2092,1158.84 2071.16,1178.34 2035.5,1182C 2005.17,1182.5 1974.84,1182.67 1944.5,1182.5C 1944.5,1317.5 1944.5,1452.5 1944.5,1587.5C 1985.17,1587.33 2025.83,1587.5 2066.5,1588C 2067.67,1589.17 2068.83,1590.33 2070,1591.5C 2070.67,1609.83 2070.67,1628.17 2070,1646.5C 2065.33,1663.83 2060.67,1681.17 2056,1698.5C 2042.86,1712.64 2029.36,1726.47 2015.5,1740C 2011.22,1741.49 2006.89,1742.82 2002.5,1744C 2090.99,1746.41 2179.32,1751.41 2267.5,1759C 2281.67,1760.31 2295.67,1762.64 2309.5,1766C 2312.09,1766.61 2313.76,1768.11 2314.5,1770.5C 2312.89,1772.98 2310.56,1774.48 2307.5,1775C 2272.11,1781.31 2236.44,1785.31 2200.5,1787C 2024.63,1796.48 1848.63,1802.15 1672.5,1804C 1291.46,1809.49 910.46,1807.49 529.5,1798C 425.011,1795.6 320.678,1790.27 216.5,1782C 201.013,1780.65 185.68,1778.31 170.5,1775C 167.445,1774.48 165.111,1772.98 163.5,1770.5C 164.24,1768.11 165.907,1766.61 168.5,1766C 182.32,1762.64 196.32,1760.31 210.5,1759C 245.433,1755.47 280.433,1752.8 315.5,1751C 363.837,1748.64 412.17,1746.3 460.5,1744C 455.744,1742.98 451.077,1741.64 446.5,1740C 432.27,1726.44 418.77,1712.27 406,1697.5C 401.667,1681.17 397.333,1664.83 393,1648.5C 392.333,1629.17 392.333,1609.83 393,1590.5C 393.833,1589.67 394.667,1588.83 395.5,1588C 425.832,1587.5 456.165,1587.33 486.5,1587.5C 485.853,1500.34 486.186,1413.17 487.5,1326C 487.152,1292.66 486.818,1259.33 486.5,1226C 487.321,1159.85 487.821,1093.68 488,1027.5C 489.167,1026.33 490.333,1025.17 491.5,1024C 500.16,1023.5 508.827,1023.33 517.5,1023.5C 517.5,977.5 517.5,931.5 517.5,885.5C 487.477,887.079 465.977,874.413 453,847.5C 417.333,762.167 381.667,676.833 346,591.5C 337.126,556.415 348.959,530.915 381.5,515C 535.5,450.333 689.5,385.667 843.5,321C 848.664,319.631 853.664,318.131 858.5,316.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7147ed",
    d: "M 857.5,325.5 C 877.712,323.086 894.545,329.419 908,344.5C 909.934,348.759 912.268,352.759 915,356.5C 950.391,441.615 986.057,526.615 1022,611.5C 1030.71,643.573 1019.88,666.407 989.5,680C 836.085,744.138 682.752,808.472 529.5,873C 497.229,882.446 474.063,871.946 460,841.5C 424.472,757.248 389.138,672.915 354,588.5C 346.495,558.347 356.662,536.514 384.5,523C 542.087,456.648 699.753,390.814 857.5,325.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf9fe",
    d: "M 847.5,378.5 C 873.172,390.02 888.672,409.687 894,437.5C 895.865,451.979 894.199,465.979 889,479.5C 886.316,478.932 883.816,477.932 881.5,476.5C 894.329,435.333 881.662,404.833 843.5,385C 844.719,382.722 846.052,380.555 847.5,378.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#241f20",
    d: "M 1271.5,394.5 C 1291.41,394.742 1302.41,404.742 1304.5,424.5C 1302.82,442.852 1292.82,452.852 1274.5,454.5C 1256.17,452.833 1246.17,442.833 1244.5,424.5C 1245.88,407.457 1254.88,397.457 1271.5,394.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfafe",
    d: "M 838.5,398.5 C 860.811,408.102 872.478,425.102 873.5,449.5C 873.67,456.65 872.336,463.484 869.5,470C 866.087,471.203 863.754,470.203 862.5,467C 870.076,438.987 861.076,418.154 835.5,404.5C 837.038,402.757 838.038,400.757 838.5,398.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6db60",
    d: "M 1816.5,397.5 C 1823.77,428.76 1831.44,459.927 1839.5,491C 1841.97,491.706 1844.3,491.373 1846.5,490C 1871.33,469.167 1896.17,448.333 1921,427.5C 1921.17,427.833 1921.33,428.167 1921.5,428.5C 1900.76,454.318 1880.26,480.318 1860,506.5C 1859.86,508.432 1860.36,510.266 1861.5,512C 1893.64,519.357 1925.97,525.857 1958.5,531.5C 1953.5,532.167 1948.5,532.833 1943.5,533.5C 1915.15,533.348 1886.81,534.014 1858.5,535.5C 1856.88,536.869 1856.38,538.536 1857,540.5C 1872.27,569.7 1886.93,599.033 1901,628.5C 1880.67,603.5 1860.33,578.5 1840,553.5C 1836.53,550.582 1833.53,550.915 1831,554.5C 1817.47,583.415 1804.14,612.415 1791,641.5C 1791.34,634.785 1792.34,628.118 1794,621.5C 1799.71,595.935 1805.55,570.435 1811.5,545C 1810.16,542.984 1808.33,541.817 1806,541.5C 1774.09,549.436 1742.26,557.269 1710.5,565C 1740.14,550.182 1769.8,535.349 1799.5,520.5C 1800.99,516.817 1799.99,513.984 1796.5,512C 1771.5,493 1746.5,474 1721.5,455C 1751.73,468.422 1781.89,482.255 1812,496.5C 1813.51,495.743 1814.85,494.743 1816,493.5C 1815.7,468.844 1815.53,444.178 1815.5,419.5C 1815.18,411.981 1815.51,404.648 1816.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828d45",
    d: "M 1816.5,397.5 C 1815.51,404.648 1815.18,411.981 1815.5,419.5C 1814.34,410.676 1814.18,401.676 1815,392.5C 1815.61,394.154 1816.11,395.821 1816.5,397.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eb4776",
    d: "M 1268.5,404.5 C 1286.98,403.479 1295.48,412.146 1294,430.5C 1287.56,443.961 1277.4,447.794 1263.5,442C 1253.76,433.696 1251.93,423.863 1258,412.5C 1260.94,408.963 1264.44,406.297 1268.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#221e1f",
    d: "M 323.5,410.5 C 343.803,410.443 350.97,420.109 345,439.5C 274.833,509.667 204.667,579.833 134.5,650C 118.518,656.177 108.518,651.01 104.5,634.5C 105.034,630.63 106.2,626.963 108,623.5C 176.472,554.027 245.306,484.861 314.5,416C 317.263,413.626 320.263,411.792 323.5,410.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 830.5,417.5 C 840.058,421.223 846.892,427.89 851,437.5C 852.506,444.433 852.839,451.433 852,458.5C 851.261,460.221 850.427,461.887 849.5,463.5C 847.271,462.423 844.937,461.756 842.5,461.5C 848.119,444.922 843.286,432.589 828,424.5C 828.756,422.285 829.589,419.951 830.5,417.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0aec2",
    d: "M 325.5,419.5 C 337.424,420.259 340.59,425.926 335,436.5C 266.833,504.667 198.667,572.833 130.5,641C 121.962,645.728 116.629,643.395 114.5,634C 114.384,631.456 115.217,629.289 117,627.5C 186.395,557.938 255.895,488.605 325.5,419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262224",
    d: "M 498.5,520.5 C 504.926,520.03 510.426,522.03 515,526.5C 526.333,553.167 537.667,579.833 549,606.5C 550.985,617.691 546.485,624.857 535.5,628C 506.833,640 478.167,652 449.5,664C 439.267,667.497 432.1,664.331 428,654.5C 416.571,627.874 405.738,601.04 395.5,574C 396.133,567.399 399.467,562.732 405.5,560C 436.821,547.333 467.821,534.166 498.5,520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 500.5,528.5 C 507.227,529.061 510.727,532.728 511,539.5C 502.932,543.191 494.766,546.691 486.5,550C 485.667,550.833 484.833,551.667 484,552.5C 482.11,557.947 479.943,563.28 477.5,568.5C 474.841,570.771 471.841,571.938 468.5,572C 464.9,564.13 461.566,556.13 458.5,548C 458.833,547.5 459.167,547 459.5,546.5C 473.374,540.724 487.04,534.724 500.5,528.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e282e",
    d: "M 1758.5,534.5 C 1632,533.833 1505.33,533.5 1378.5,533.5C 1251.5,533.5 1124.83,534.167 998.5,535.5C 997.596,534.791 997.263,533.791 997.5,532.5C 1251.83,532.167 1506.17,532.5 1760.5,533.5C 1760.04,534.298 1759.38,534.631 1758.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#515533",
    d: "M 1958.5,531.5 C 1959.38,531.369 1960.04,531.702 1960.5,532.5C 1954.87,533.495 1949.21,533.829 1943.5,533.5C 1948.5,532.833 1953.5,532.167 1958.5,531.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2abf0",
    d: "M 1758.5,534.5 C 1732.37,547.064 1706.37,559.897 1680.5,573C 1680.01,575.027 1680.01,577.193 1680.5,579.5C 1721.3,569.092 1762.13,558.759 1803,548.5C 1803.5,548.833 1804,549.167 1804.5,549.5C 1799.73,567.67 1795.73,586.004 1792.5,604.5C 1537.5,604.833 1282.5,604.5 1027.5,603.5C 1017.82,580.807 1008.15,558.141 998.5,535.5C 1124.83,534.167 1251.5,533.5 1378.5,533.5C 1505.33,533.5 1632,533.833 1758.5,534.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262124",
    d: "M 924.5,536.5 C 943.52,535.021 952.353,543.687 951,562.5C 949.657,566.51 947.491,570.01 944.5,573C 919.616,583.942 894.616,594.609 869.5,605C 849.543,609.045 840.043,600.878 841,580.5C 842.647,575.844 845.48,572.011 849.5,569C 874.559,558.133 899.559,547.3 924.5,536.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c1aaef",
    d: "M 1935.5,634.5 C 1935.5,644.833 1935.5,655.167 1935.5,665.5C 1911.83,665.5 1888.17,665.5 1864.5,665.5C 1864.67,654.162 1864.5,642.828 1864,631.5C 1862.75,627.918 1861.75,624.251 1861,620.5C 1857.17,616.667 1853.33,612.833 1849.5,609C 1844.98,607.262 1840.31,606.095 1835.5,605.5C 1828.83,604.833 1822.17,604.167 1815.5,603.5C 1822.06,588.704 1828.9,574.037 1836,559.5C 1861.24,589.649 1886.24,619.983 1911,650.5C 1912.68,652.351 1914.52,654.018 1916.5,655.5C 1919.53,654.988 1920.7,653.322 1920,650.5C 1901.72,614.776 1883.55,578.942 1865.5,543C 1872.32,543.706 1878.99,545.373 1885.5,548C 1897.67,560.167 1909.83,572.333 1922,584.5C 1927.12,600.99 1931.62,617.657 1935.5,634.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 925.5,544.5 C 938.821,542.656 944.655,548.323 943,561.5C 941.878,563.624 940.378,565.457 938.5,567C 915.167,577 891.833,587 868.5,597C 855.415,600.908 848.915,596.074 849,582.5C 850.442,578.725 852.942,575.892 856.5,574C 879.821,564.666 902.821,554.833 925.5,544.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 512.5,547.5 C 513.822,547.33 514.989,547.663 516,548.5C 518.682,554.834 521.015,561.167 523,567.5C 512.457,571.854 501.957,576.354 491.5,581C 490.365,581.749 489.365,581.583 488.5,580.5C 487.003,577.842 486.003,575.009 485.5,572C 486.909,567.013 488.742,562.18 491,557.5C 498.182,553.99 505.349,550.656 512.5,547.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 448.5,550.5 C 449.496,550.414 450.329,550.748 451,551.5C 454.305,559.277 457.472,567.11 460.5,575C 458.311,577.264 455.644,578.764 452.5,579.5C 446.175,577.449 440.008,575.116 434,572.5C 425.122,576.021 416.288,579.688 407.5,583.5C 405.684,580.557 404.351,577.391 403.5,574C 403.99,571.497 405.323,569.497 407.5,568C 421.39,562.434 435.057,556.601 448.5,550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf9fa",
    d: "M 523.5,575.5 C 524.978,575.238 526.311,575.571 527.5,576.5C 529.972,582.583 532.639,588.583 535.5,594.5C 527.535,598.159 519.535,601.826 511.5,605.5C 506.5,603.333 501.5,601.167 496.5,599C 494.67,595.676 493.337,592.176 492.5,588.5C 503.236,584.961 513.569,580.627 523.5,575.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 477.5,577.5 C 481.178,584.365 484.512,591.532 487.5,599C 481.234,602.821 474.567,605.988 467.5,608.5C 464.227,601.62 461.227,594.62 458.5,587.5C 458.833,586.833 459.167,586.167 459.5,585.5C 465.685,583.004 471.685,580.337 477.5,577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfafb",
    d: "M 431.5,581.5 C 437.423,582.418 443.09,584.252 448.5,587C 450.279,590.056 451.946,593.223 453.5,596.5C 442.034,601.599 430.534,606.599 419,611.5C 416.029,605.058 413.196,598.558 410.5,592C 417.254,587.956 424.254,584.456 431.5,581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262124",
    d: "M 802.5,588.5 C 822.357,589.209 829.857,599.209 825,618.5C 823.207,621.295 821.04,623.795 818.5,626C 792.731,637.551 766.731,648.551 740.5,659C 723.201,659.366 715.034,650.866 716,633.5C 717.617,629.103 720.117,625.269 723.5,622C 749.702,610.224 776.035,599.058 802.5,588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbfbfb",
    d: "M 802.5,596.5 C 815.366,595.906 820.532,601.906 818,614.5C 816.954,616.09 815.787,617.59 814.5,619C 789.616,629.942 764.616,640.609 739.5,651C 727.891,651.639 722.724,646.139 724,634.5C 725.458,632.04 727.291,629.873 729.5,628C 753.923,617.449 778.256,606.949 802.5,596.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 537.5,602.5 C 541.691,606.817 542.358,611.65 539.5,617C 525.164,623.556 510.664,629.723 496,635.5C 491.801,627.604 487.968,619.438 484.5,611C 486.961,608.946 489.794,607.446 493,606.5C 498.935,609.033 504.935,611.367 511,613.5C 520.197,610.478 529.03,606.811 537.5,602.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#635873",
    d: "M 1815.5,603.5 C 1822.17,604.167 1828.83,604.833 1835.5,605.5C 1828.47,605.83 1821.47,605.497 1814.5,604.5C 1814.62,603.893 1814.96,603.56 1815.5,603.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fafafa",
    d: "M 454.5,604.5 C 455.496,604.414 456.329,604.748 457,605.5C 458.167,608.333 459.333,611.167 460.5,614C 458.402,618.793 456.402,623.626 454.5,628.5C 446.641,632.066 438.808,635.733 431,639.5C 427.326,632.8 424.659,625.8 423,618.5C 433.626,613.911 444.126,609.244 454.5,604.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5b3b4",
    d: "M 1789.5,613.5 C 1536.5,612.834 1283.83,613.501 1031.5,615.5C 1030.6,614.791 1030.26,613.791 1030.5,612.5C 1283.67,612.167 1536.67,612.5 1789.5,613.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1789.5,613.5 C 1786.31,630.801 1782.65,647.968 1778.5,665C 1667.17,665.333 1555.83,665.667 1444.5,666C 1410.69,669.812 1390.19,688.312 1383,721.5C 1382.02,857.52 1382.35,993.52 1384,1129.5C 1389.75,1154.18 1404.59,1170.68 1428.5,1179C 1433.49,1179.75 1438.49,1180.42 1443.5,1181C 1581.17,1181.5 1718.83,1181.67 1856.5,1181.5C 1856.67,1283.5 1856.5,1385.5 1856,1487.5C 1853.99,1498.51 1847.49,1505.35 1836.5,1508C 1552.5,1508.5 1268.5,1508.67 984.5,1508.5C 978.352,1352.51 972.352,1196.51 966.5,1040.5C 966.167,1036.5 965.833,1032.5 965.5,1028.5C 963.814,1027.14 962.148,1025.81 960.5,1024.5C 926.337,1023.5 892.004,1023.17 857.5,1023.5C 857.784,1021.59 857.451,1019.92 856.5,1018.5C 855.895,988.979 850.728,960.312 841,932.5C 835.886,919.094 828.386,907.26 818.5,897C 792.301,880.778 768.468,883.611 747,905.5C 742.833,912.5 738.667,919.5 734.5,926.5C 730.414,919.997 726.581,913.33 723,906.5C 707.786,887.149 688.286,880.982 664.5,888C 655.521,891.985 648.021,897.818 642,905.5C 631.429,922.856 623.763,941.522 619,961.5C 615.422,982.046 612.922,1002.71 611.5,1023.5C 609.833,1023.5 608.167,1023.5 606.5,1023.5C 606.5,965.5 606.5,907.5 606.5,849.5C 738.845,793.771 871.178,737.938 1003.5,682C 1028.08,666.324 1037.42,644.157 1031.5,615.5C 1283.83,613.501 1536.5,612.834 1789.5,613.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 1856.5,665.5 C 1833.33,665.831 1810.33,665.498 1787.5,664.5C 1795.23,647.482 1803.06,630.482 1811,613.5C 1822.66,611.646 1834.16,612.479 1845.5,616C 1848.33,618.833 1851.17,621.667 1854,624.5C 1854.67,627.167 1855.33,629.833 1856,632.5C 1856.5,643.495 1856.67,654.495 1856.5,665.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9f9",
    d: "M 474.5,613.5 C 475.675,613.281 476.675,613.614 477.5,614.5C 480.833,622.5 484.167,630.5 487.5,638.5C 473.659,644.95 459.659,651.117 445.5,657C 443.5,657.667 441.5,657.667 439.5,657C 436.732,654.131 434.732,650.798 433.5,647C 441.716,643.059 450.049,639.392 458.5,636C 462.305,630.225 465.472,624.058 468,617.5C 470.314,616.267 472.481,614.933 474.5,613.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262225",
    d: "M 677.5,640.5 C 694.219,640.586 702.386,648.92 702,665.5C 700.645,670.38 698.145,674.547 694.5,678C 668.48,689.783 642.147,700.783 615.5,711C 602.607,712.63 594.441,707.13 591,694.5C 589.815,686.032 592.649,679.199 599.5,674C 625.455,662.522 651.455,651.356 677.5,640.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 675.5,649.5 C 688.821,647.656 694.655,653.323 693,666.5C 691.878,668.624 690.378,670.457 688.5,672C 664.063,682.885 639.397,693.218 614.5,703C 603.402,703.902 598.235,698.735 599,687.5C 600.442,683.725 602.942,680.892 606.5,679C 629.821,669.666 652.821,659.833 675.5,649.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#716e70",
    d: "M 1787.5,664.5 C 1810.33,665.498 1833.33,665.831 1856.5,665.5C 1833.33,666.829 1810,666.829 1786.5,665.5C 1786.62,664.893 1786.96,664.56 1787.5,664.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b5d7e",
    d: "M 1935.5,634.5 C 1936.49,644.987 1936.83,655.654 1936.5,666.5C 1912.33,666.831 1888.33,666.498 1864.5,665.5C 1888.17,665.5 1911.83,665.5 1935.5,665.5C 1935.5,655.167 1935.5,644.833 1935.5,634.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ed4a79",
    d: "M 1450.5,672.5 C 1448.74,676.57 1449.91,677.903 1454,676.5C 1454.49,675.207 1454.66,673.873 1454.5,672.5C 1462.5,672.5 1470.5,672.5 1478.5,672.5C 1477.17,675.047 1478,676.714 1481,677.5C 1483.61,676.5 1484.11,674.833 1482.5,672.5C 1490.5,672.5 1498.5,672.5 1506.5,672.5C 1505.83,676.676 1507.33,678.009 1511,676.5C 1511.49,675.207 1511.66,673.873 1511.5,672.5C 1519.5,672.5 1527.5,672.5 1535.5,672.5C 1533.74,676.57 1534.91,677.903 1539,676.5C 1539.49,675.207 1539.66,673.873 1539.5,672.5C 1547.5,672.5 1555.5,672.5 1563.5,672.5C 1563.01,674.948 1563.84,676.615 1566,677.5C 1568.61,676.5 1569.11,674.833 1567.5,672.5C 1575.5,672.5 1583.5,672.5 1591.5,672.5C 1590.83,676.676 1592.33,678.009 1596,676.5C 1596.49,675.207 1596.66,673.873 1596.5,672.5C 1604.5,672.5 1612.5,672.5 1620.5,672.5C 1619.14,674.802 1619.81,676.468 1622.5,677.5C 1625.19,676.468 1625.86,674.802 1624.5,672.5C 1632.5,672.5 1640.5,672.5 1648.5,672.5C 1648.01,674.948 1648.84,676.615 1651,677.5C 1653.61,676.5 1654.11,674.833 1652.5,672.5C 1660.5,672.5 1668.5,672.5 1676.5,672.5C 1675.83,676.676 1677.33,678.009 1681,676.5C 1681.49,675.207 1681.66,673.873 1681.5,672.5C 1689.5,672.5 1697.5,672.5 1705.5,672.5C 1704.14,674.802 1704.81,676.468 1707.5,677.5C 1710.19,676.468 1710.86,674.802 1709.5,672.5C 1717.5,672.5 1725.5,672.5 1733.5,672.5C 1732.83,676.676 1734.33,678.009 1738,676.5C 1738.49,675.207 1738.66,673.873 1738.5,672.5C 1746.5,672.5 1754.5,672.5 1762.5,672.5C 1760.74,676.57 1761.91,677.903 1766,676.5C 1766.49,675.207 1766.66,673.873 1766.5,672.5C 1774.55,673.072 1782.55,673.072 1790.5,672.5C 1789.14,674.802 1789.81,676.468 1792.5,677.5C 1795.19,676.468 1795.86,674.802 1794.5,672.5C 1802.5,672.5 1810.5,672.5 1818.5,672.5C 1817.83,676.676 1819.33,678.009 1823,676.5C 1823.49,675.207 1823.66,673.873 1823.5,672.5C 1831.5,672.5 1839.5,672.5 1847.5,672.5C 1845.74,676.57 1846.91,677.903 1851,676.5C 1851.49,675.207 1851.66,673.873 1851.5,672.5C 1859.5,672.5 1867.5,672.5 1875.5,672.5C 1875.01,674.948 1875.84,676.615 1878,677.5C 1880.61,676.5 1881.11,674.833 1879.5,672.5C 1887.5,672.5 1895.5,672.5 1903.5,672.5C 1902.83,676.676 1904.33,678.009 1908,676.5C 1908.49,675.207 1908.66,673.873 1908.5,672.5C 1916.5,672.5 1924.5,672.5 1932.5,672.5C 1931.15,677.558 1932.65,678.558 1937,675.5C 1937.47,674.423 1937.3,673.423 1936.5,672.5C 1944.5,672.5 1952.5,672.5 1960.5,672.5C 1960.01,674.948 1960.84,676.615 1963,677.5C 1965.61,676.5 1966.11,674.833 1964.5,672.5C 1972.5,672.5 1980.5,672.5 1988.5,672.5C 1987.83,676.676 1989.33,678.009 1993,676.5C 1993.49,675.207 1993.66,673.873 1993.5,672.5C 2001.5,672.5 2009.5,672.5 2017.5,672.5C 2016.14,674.802 2016.81,676.468 2019.5,677.5C 2022.19,676.468 2022.86,674.802 2021.5,672.5C 2029.58,672.403 2037.58,673.07 2045.5,674.5C 2046.58,677.972 2048.24,678.305 2050.5,675.5C 2053.62,676.559 2056.62,677.892 2059.5,679.5C 2059.26,684.508 2060.92,685.508 2064.5,682.5C 2078.76,691.764 2087.43,704.764 2090.5,721.5C 2086.44,724.085 2086.78,726.085 2091.5,727.5C 2091.5,730.167 2091.5,732.833 2091.5,735.5C 2086.17,737.5 2086.17,739.5 2091.5,741.5C 2091.5,744.5 2091.5,747.5 2091.5,750.5C 1857.5,750.5 1623.5,750.5 1389.5,750.5C 1389.5,742.5 1389.5,734.5 1389.5,726.5C 1389.24,718.747 1391.24,711.747 1395.5,705.5C 1398.31,705.042 1398.98,703.709 1397.5,701.5C 1409.45,681.919 1427.12,672.253 1450.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ecef",
    d: "M 1450.5,672.5 C 1451.83,672.5 1453.17,672.5 1454.5,672.5C 1454.66,673.873 1454.49,675.207 1454,676.5C 1449.91,677.903 1448.74,676.57 1450.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e4e9",
    d: "M 1478.5,672.5 C 1479.83,672.5 1481.17,672.5 1482.5,672.5C 1484.11,674.833 1483.61,676.5 1481,677.5C 1478,676.714 1477.17,675.047 1478.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eaed",
    d: "M 1506.5,672.5 C 1508.17,672.5 1509.83,672.5 1511.5,672.5C 1511.66,673.873 1511.49,675.207 1511,676.5C 1507.33,678.009 1505.83,676.676 1506.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7eaed",
    d: "M 1535.5,672.5 C 1536.83,672.5 1538.17,672.5 1539.5,672.5C 1539.66,673.873 1539.49,675.207 1539,676.5C 1534.91,677.903 1533.74,676.57 1535.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7eaee",
    d: "M 1563.5,672.5 C 1564.83,672.5 1566.17,672.5 1567.5,672.5C 1569.11,674.833 1568.61,676.5 1566,677.5C 1563.84,676.615 1563.01,674.948 1563.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eaed",
    d: "M 1591.5,672.5 C 1593.17,672.5 1594.83,672.5 1596.5,672.5C 1596.66,673.873 1596.49,675.207 1596,676.5C 1592.33,678.009 1590.83,676.676 1591.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e9ec",
    d: "M 1620.5,672.5 C 1621.83,672.5 1623.17,672.5 1624.5,672.5C 1625.86,674.802 1625.19,676.468 1622.5,677.5C 1619.81,676.468 1619.14,674.802 1620.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ecef",
    d: "M 1648.5,672.5 C 1649.83,672.5 1651.17,672.5 1652.5,672.5C 1654.11,674.833 1653.61,676.5 1651,677.5C 1648.84,676.615 1648.01,674.948 1648.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6e9ec",
    d: "M 1676.5,672.5 C 1678.17,672.5 1679.83,672.5 1681.5,672.5C 1681.66,673.873 1681.49,675.207 1681,676.5C 1677.33,678.009 1675.83,676.676 1676.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e9ed",
    d: "M 1705.5,672.5 C 1706.83,672.5 1708.17,672.5 1709.5,672.5C 1710.86,674.802 1710.19,676.468 1707.5,677.5C 1704.81,676.468 1704.14,674.802 1705.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6e9ec",
    d: "M 1733.5,672.5 C 1735.17,672.5 1736.83,672.5 1738.5,672.5C 1738.66,673.873 1738.49,675.207 1738,676.5C 1734.33,678.009 1732.83,676.676 1733.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ecef",
    d: "M 1762.5,672.5 C 1763.83,672.5 1765.17,672.5 1766.5,672.5C 1766.66,673.873 1766.49,675.207 1766,676.5C 1761.91,677.903 1760.74,676.57 1762.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e9ec",
    d: "M 1790.5,672.5 C 1791.83,672.5 1793.17,672.5 1794.5,672.5C 1795.86,674.802 1795.19,676.468 1792.5,677.5C 1789.81,676.468 1789.14,674.802 1790.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eaed",
    d: "M 1818.5,672.5 C 1820.17,672.5 1821.83,672.5 1823.5,672.5C 1823.66,673.873 1823.49,675.207 1823,676.5C 1819.33,678.009 1817.83,676.676 1818.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ebee",
    d: "M 1847.5,672.5 C 1848.83,672.5 1850.17,672.5 1851.5,672.5C 1851.66,673.873 1851.49,675.207 1851,676.5C 1846.91,677.903 1845.74,676.57 1847.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7eaed",
    d: "M 1875.5,672.5 C 1876.83,672.5 1878.17,672.5 1879.5,672.5C 1881.11,674.833 1880.61,676.5 1878,677.5C 1875.84,676.615 1875.01,674.948 1875.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eaed",
    d: "M 1903.5,672.5 C 1905.17,672.5 1906.83,672.5 1908.5,672.5C 1908.66,673.873 1908.49,675.207 1908,676.5C 1904.33,678.009 1902.83,676.676 1903.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e4e9",
    d: "M 1932.5,672.5 C 1933.83,672.5 1935.17,672.5 1936.5,672.5C 1937.3,673.423 1937.47,674.423 1937,675.5C 1932.65,678.558 1931.15,677.558 1932.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ebee",
    d: "M 1960.5,672.5 C 1961.83,672.5 1963.17,672.5 1964.5,672.5C 1966.11,674.833 1965.61,676.5 1963,677.5C 1960.84,676.615 1960.01,674.948 1960.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6e9ed",
    d: "M 1988.5,672.5 C 1990.17,672.5 1991.83,672.5 1993.5,672.5C 1993.66,673.873 1993.49,675.207 1993,676.5C 1989.33,678.009 1987.83,676.676 1988.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7e9ec",
    d: "M 2017.5,672.5 C 2018.83,672.5 2020.17,672.5 2021.5,672.5C 2022.86,674.802 2022.19,676.468 2019.5,677.5C 2016.81,676.468 2016.14,674.802 2017.5,672.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3e2e7",
    d: "M 2045.5,674.5 C 2047.29,674.366 2048.96,674.699 2050.5,675.5C 2048.24,678.305 2046.58,677.972 2045.5,674.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1435.5,679.5 C 1437.17,679.5 1438.83,679.5 1440.5,679.5C 1441.17,683.676 1439.67,685.009 1436,683.5C 1435.51,682.207 1435.34,680.873 1435.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1464.5,679.5 C 1465.87,679.343 1467.21,679.51 1468.5,680C 1469.45,680.718 1469.62,681.551 1469,682.5C 1464.65,685.558 1463.15,684.558 1464.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1492.5,679.5 C 1496.14,678.737 1497.64,680.07 1497,683.5C 1493.33,685.009 1491.83,683.676 1492.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1521.5,679.5 C 1522.83,679.5 1524.17,679.5 1525.5,679.5C 1525.99,681.948 1525.16,683.615 1523,684.5C 1520.39,683.5 1519.89,681.833 1521.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee9ee",
    d: "M 1549.5,679.5 C 1553.14,678.737 1554.64,680.07 1554,683.5C 1549.78,684.989 1548.28,683.655 1549.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1577.5,679.5 C 1581.14,678.737 1582.64,680.07 1582,683.5C 1578.33,685.009 1576.83,683.676 1577.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1606.5,679.5 C 1607.83,679.5 1609.17,679.5 1610.5,679.5C 1610.99,681.948 1610.16,683.615 1608,684.5C 1605.39,683.5 1604.89,681.833 1606.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1634.5,679.5 C 1638.14,678.737 1639.64,680.07 1639,683.5C 1636.51,684.946 1634.67,684.279 1633.5,681.5C 1633.86,680.817 1634.2,680.15 1634.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1662.5,679.5 C 1664.17,679.5 1665.83,679.5 1667.5,679.5C 1668.17,683.676 1666.67,685.009 1663,683.5C 1662.51,682.207 1662.34,680.873 1662.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1691.5,679.5 C 1692.83,679.5 1694.17,679.5 1695.5,679.5C 1695.99,681.948 1695.16,683.615 1693,684.5C 1690.39,683.5 1689.89,681.833 1691.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1719.5,679.5 C 1723.14,678.737 1724.64,680.07 1724,683.5C 1720.33,685.009 1718.83,683.676 1719.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1747.5,679.5 C 1749.17,679.5 1750.83,679.5 1752.5,679.5C 1753.17,683.676 1751.67,685.009 1748,683.5C 1747.51,682.207 1747.34,680.873 1747.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1776.5,679.5 C 1777.87,679.343 1779.21,679.51 1780.5,680C 1781.45,680.718 1781.62,681.551 1781,682.5C 1776.65,685.558 1775.15,684.558 1776.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1804.5,679.5 C 1808.14,678.737 1809.64,680.07 1809,683.5C 1805.33,685.009 1803.83,683.676 1804.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1833.5,679.5 C 1834.83,679.5 1836.17,679.5 1837.5,679.5C 1837.99,681.948 1837.16,683.615 1835,684.5C 1832.39,683.5 1831.89,681.833 1833.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee6ec",
    d: "M 1861.5,679.5 C 1865.14,678.737 1866.64,680.07 1866,683.5C 1861.42,685.413 1859.92,684.079 1861.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1889.5,679.5 C 1893.14,678.737 1894.64,680.07 1894,683.5C 1890.33,685.009 1888.83,683.676 1889.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1918.5,679.5 C 1919.83,679.5 1921.17,679.5 1922.5,679.5C 1922.99,681.948 1922.16,683.615 1920,684.5C 1917.39,683.5 1916.89,681.833 1918.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1946.5,679.5 C 1950.14,678.737 1951.64,680.07 1951,683.5C 1948.51,684.946 1946.67,684.279 1945.5,681.5C 1945.86,680.817 1946.2,680.15 1946.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1974.5,679.5 C 1976.17,679.5 1977.83,679.5 1979.5,679.5C 1980.17,683.676 1978.67,685.009 1975,683.5C 1974.51,682.207 1974.34,680.873 1974.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f6",
    d: "M 2003.5,679.5 C 2004.83,679.5 2006.17,679.5 2007.5,679.5C 2007.99,681.948 2007.16,683.615 2005,684.5C 2002.39,683.5 2001.89,681.833 2003.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 2031.5,679.5 C 2035.14,678.737 2036.64,680.07 2036,683.5C 2032.33,685.009 2030.83,683.676 2031.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3e9ec",
    d: "M 2059.5,679.5 C 2061.67,679.75 2063.34,680.75 2064.5,682.5C 2060.92,685.508 2059.26,684.508 2059.5,679.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1421.5,686.5 C 1425.14,685.737 1426.64,687.07 1426,690.5C 1422.33,692.009 1420.83,690.676 1421.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1450.5,686.5 C 1451.83,686.5 1453.17,686.5 1454.5,686.5C 1454.99,688.948 1454.16,690.615 1452,691.5C 1449.39,690.5 1448.89,688.833 1450.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1478.5,686.5 C 1482.14,685.737 1483.64,687.07 1483,690.5C 1479.33,692.009 1477.83,690.676 1478.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1506.5,686.5 C 1510.14,685.737 1511.64,687.07 1511,690.5C 1507.33,692.009 1505.83,690.676 1506.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1535.5,686.5 C 1536.83,686.5 1538.17,686.5 1539.5,686.5C 1539.99,688.948 1539.16,690.615 1537,691.5C 1534.39,690.5 1533.89,688.833 1535.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1563.5,686.5 C 1567.14,685.737 1568.64,687.07 1568,690.5C 1564.33,692.009 1562.83,690.676 1563.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1592.5,686.5 C 1593.83,686.5 1595.17,686.5 1596.5,686.5C 1596.99,688.948 1596.16,690.615 1594,691.5C 1591.39,690.5 1590.89,688.833 1592.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee9ef",
    d: "M 1620.5,686.5 C 1624.42,685.746 1625.75,687.08 1624.5,690.5C 1620.13,692.134 1618.8,690.801 1620.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1648.5,686.5 C 1652.14,685.737 1653.64,687.07 1653,690.5C 1649.33,692.009 1647.83,690.676 1648.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1677.5,686.5 C 1678.83,686.5 1680.17,686.5 1681.5,686.5C 1681.99,688.948 1681.16,690.615 1679,691.5C 1676.39,690.5 1675.89,688.833 1677.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1705.5,686.5 C 1709.14,685.737 1710.64,687.07 1710,690.5C 1705.42,692.413 1703.92,691.079 1705.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1733.5,686.5 C 1737.14,685.737 1738.64,687.07 1738,690.5C 1734.33,692.009 1732.83,690.676 1733.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1762.5,686.5 C 1763.83,686.5 1765.17,686.5 1766.5,686.5C 1766.99,688.948 1766.16,690.615 1764,691.5C 1761.39,690.5 1760.89,688.833 1762.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1790.5,686.5 C 1794.14,685.737 1795.64,687.07 1795,690.5C 1790.42,692.413 1788.92,691.079 1790.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1818.5,686.5 C 1822.14,685.737 1823.64,687.07 1823,690.5C 1819.33,692.009 1817.83,690.676 1818.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1847.5,686.5 C 1848.83,686.5 1850.17,686.5 1851.5,686.5C 1851.99,688.948 1851.16,690.615 1849,691.5C 1846.39,690.5 1845.89,688.833 1847.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1875.5,686.5 C 1879.14,685.737 1880.64,687.07 1880,690.5C 1876.33,692.009 1874.83,690.676 1875.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef9fb",
    d: "M 1904.5,686.5 C 1908.16,686.35 1909.16,687.85 1907.5,691C 1903.71,691.487 1902.71,689.987 1904.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1932.5,686.5 C 1933.83,686.5 1935.17,686.5 1936.5,686.5C 1936.99,688.948 1936.16,690.615 1934,691.5C 1931.39,690.5 1930.89,688.833 1932.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1960.5,686.5 C 1964.14,685.737 1965.64,687.07 1965,690.5C 1961.33,692.009 1959.83,690.676 1960.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1989.5,686.5 C 1990.83,686.5 1992.17,686.5 1993.5,686.5C 1993.99,688.948 1993.16,690.615 1991,691.5C 1988.39,690.5 1987.89,688.833 1989.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 2017.5,686.5 C 2021.14,685.737 2022.64,687.07 2022,690.5C 2017.42,692.413 2015.92,691.079 2017.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 2045.5,686.5 C 2049.14,685.737 2050.64,687.07 2050,690.5C 2046.33,692.009 2044.83,690.676 2045.5,686.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#292222",
    d: "M 1961.5,728.5 C 1947.68,734.839 1937.52,731.172 1931,717.5C 1930.29,713.113 1930.46,708.78 1931.5,704.5C 1932.67,703.486 1933.34,702.153 1933.5,700.5C 1944.33,689.864 1955.17,689.864 1966,700.5C 1971.76,711.033 1970.26,720.366 1961.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#292022",
    d: "M 2031.5,696.5 C 2031.83,697.5 2032.5,698.167 2033.5,698.5C 2039.49,705.978 2040.16,713.978 2035.5,722.5C 2034.03,723.436 2033.03,724.77 2032.5,726.5C 2029.3,728.558 2025.97,730.225 2022.5,731.5C 2020.5,731.5 2018.5,731.5 2016.5,731.5C 2012.95,730.724 2009.61,729.391 2006.5,727.5C 2005.5,725.833 2004.17,724.5 2002.5,723.5C 1997.93,714.65 1998.6,706.317 2004.5,698.5C 2005.69,697.728 2006.69,696.728 2007.5,695.5C 2015.67,691.291 2023.67,691.625 2031.5,696.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#262125",
    d: "M 550.5,693.5 C 567.863,692.371 576.696,700.371 577,717.5C 575.568,722.861 572.734,727.361 568.5,731C 542.731,742.551 516.731,753.551 490.5,764C 473.222,764.387 465.055,755.887 466,738.5C 467.617,734.103 470.117,730.269 473.5,727C 499.192,715.72 524.859,704.553 550.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1407.5,693.5 C 1411.14,692.737 1412.64,694.07 1412,697.5C 1408.33,699.009 1406.83,697.676 1407.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1436.5,693.5 C 1440.16,693.35 1441.16,694.85 1439.5,698C 1435.71,698.487 1434.71,696.987 1436.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1464.5,693.5 C 1468.14,692.737 1469.64,694.07 1469,697.5C 1464.42,699.413 1462.92,698.079 1464.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1492.5,693.5 C 1496.14,692.737 1497.64,694.07 1497,697.5C 1493.33,699.009 1491.83,697.676 1492.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1521.5,693.5 C 1522.83,693.5 1524.17,693.5 1525.5,693.5C 1525.99,695.948 1525.16,697.615 1523,698.5C 1520.39,697.5 1519.89,695.833 1521.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1549.5,693.5 C 1553.14,692.737 1554.64,694.07 1554,697.5C 1549.42,699.413 1547.92,698.079 1549.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1577.5,693.5 C 1581.14,692.737 1582.64,694.07 1582,697.5C 1578.33,699.009 1576.83,697.676 1577.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1606.5,693.5 C 1607.83,693.5 1609.17,693.5 1610.5,693.5C 1610.99,695.948 1610.16,697.615 1608,698.5C 1605.39,697.5 1604.89,695.833 1606.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1634.5,693.5 C 1638.14,692.737 1639.64,694.07 1639,697.5C 1634.42,699.413 1632.92,698.079 1634.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1663.5,693.5 C 1667.16,693.35 1668.16,694.85 1666.5,698C 1662.71,698.487 1661.71,696.987 1663.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f4",
    d: "M 1691.5,693.5 C 1692.83,693.5 1694.17,693.5 1695.5,693.5C 1695.5,695.167 1695.5,696.833 1695.5,698.5C 1691.07,699.078 1689.73,697.411 1691.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f4",
    d: "M 1719.5,693.5 C 1723.68,692.831 1725.01,694.331 1723.5,698C 1722.21,698.49 1720.87,698.657 1719.5,698.5C 1719.5,696.833 1719.5,695.167 1719.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1748.5,693.5 C 1752.16,693.35 1753.16,694.85 1751.5,698C 1747.71,698.487 1746.71,696.987 1748.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1776.5,693.5 C 1780.14,692.737 1781.64,694.07 1781,697.5C 1776.42,699.413 1774.92,698.079 1776.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1804.5,693.5 C 1808.14,692.737 1809.64,694.07 1809,697.5C 1805.33,699.009 1803.83,697.676 1804.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefafb",
    d: "M 1833.5,693.5 C 1837.16,693.35 1838.16,694.85 1836.5,698C 1832.71,698.487 1831.71,696.987 1833.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1861.5,693.5 C 1865.14,692.737 1866.64,694.07 1866,697.5C 1861.42,699.413 1859.92,698.079 1861.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1889.5,693.5 C 1893.14,692.737 1894.64,694.07 1894,697.5C 1890.33,699.009 1888.83,697.676 1889.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1918.5,693.5 C 1919.83,693.5 1921.17,693.5 1922.5,693.5C 1922.99,695.948 1922.16,697.615 1920,698.5C 1917.39,697.5 1916.89,695.833 1918.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1975.5,693.5 C 1979.16,693.35 1980.16,694.85 1978.5,698C 1974.71,698.487 1973.71,696.987 1975.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6ecef",
    d: "M 2007.5,695.5 C 2006.69,696.728 2005.69,697.728 2004.5,698.5C 2001.68,696.27 2002.02,694.603 2005.5,693.5C 2006.71,693.747 2007.38,694.414 2007.5,695.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf0f3",
    d: "M 2033.5,698.5 C 2032.5,698.167 2031.83,697.5 2031.5,696.5C 2031.5,695.5 2031.5,694.5 2031.5,693.5C 2035.14,692.737 2036.64,694.07 2036,697.5C 2035.33,698.252 2034.5,698.586 2033.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 2060.5,693.5 C 2064.16,693.35 2065.16,694.85 2063.5,698C 2059.71,698.487 2058.71,696.987 2060.5,693.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6db60",
    d: "M 1946.5,698.5 C 1961.44,699.368 1965.94,706.701 1960,720.5C 1954.21,725.18 1948.04,725.68 1941.5,722C 1937.76,717.483 1936.59,712.316 1938,706.5C 1940.07,702.923 1942.91,700.256 1946.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e84775",
    d: "M 2015.5,698.5 C 2028.88,698.911 2033.71,705.578 2030,718.5C 2025.87,724.115 2020.37,725.948 2013.5,724C 2005.37,719.251 2003.54,712.751 2008,704.5C 2010.11,701.879 2012.61,699.879 2015.5,698.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1422.5,700.5 C 1426.16,700.35 1427.16,701.85 1425.5,705C 1421.71,705.487 1420.71,703.987 1422.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1450.5,700.5 C 1451.83,700.5 1453.17,700.5 1454.5,700.5C 1454.5,702.167 1454.5,703.833 1454.5,705.5C 1450.07,706.078 1448.73,704.411 1450.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef0f4",
    d: "M 1478.5,700.5 C 1482.68,699.831 1484.01,701.331 1482.5,705C 1481.21,705.49 1479.87,705.657 1478.5,705.5C 1478.5,703.833 1478.5,702.167 1478.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1507.5,700.5 C 1511.16,700.35 1512.16,701.85 1510.5,705C 1506.71,705.487 1505.71,703.987 1507.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1535.5,700.5 C 1536.83,700.5 1538.17,700.5 1539.5,700.5C 1539.5,702.167 1539.5,703.833 1539.5,705.5C 1535.07,706.078 1533.73,704.411 1535.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1563.5,700.5 C 1567.68,699.831 1569.01,701.331 1567.5,705C 1566.21,705.49 1564.87,705.657 1563.5,705.5C 1563.5,703.833 1563.5,702.167 1563.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1592.5,700.5 C 1596.16,700.35 1597.16,701.85 1595.5,705C 1591.71,705.487 1590.71,703.987 1592.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1620.5,700.5 C 1624.14,699.737 1625.64,701.07 1625,704.5C 1620.42,706.413 1618.92,705.079 1620.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1648.5,700.5 C 1652.68,699.831 1654.01,701.331 1652.5,705C 1651.21,705.49 1649.87,705.657 1648.5,705.5C 1648.5,703.833 1648.5,702.167 1648.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefafb",
    d: "M 1677.5,700.5 C 1681.16,700.35 1682.16,701.85 1680.5,705C 1676.71,705.487 1675.71,703.987 1677.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1705.5,700.5 C 1709.14,699.737 1710.64,701.07 1710,704.5C 1705.42,706.413 1703.92,705.079 1705.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefafb",
    d: "M 1734.5,700.5 C 1738.16,700.35 1739.16,701.85 1737.5,705C 1733.71,705.487 1732.71,703.987 1734.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1762.5,700.5 C 1765.91,700.384 1767.24,702.05 1766.5,705.5C 1762.07,706.078 1760.73,704.411 1762.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde8ee",
    d: "M 1790.5,700.5 C 1794.14,699.737 1795.64,701.07 1795,704.5C 1790.42,706.413 1788.92,705.079 1790.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1819.5,700.5 C 1823.16,700.35 1824.16,701.85 1822.5,705C 1818.71,705.487 1817.71,703.987 1819.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 1847.5,700.5 C 1848.83,700.5 1850.17,700.5 1851.5,700.5C 1851.5,702.167 1851.5,703.833 1851.5,705.5C 1847.07,706.078 1845.73,704.411 1847.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f4",
    d: "M 1875.5,700.5 C 1879.68,699.831 1881.01,701.331 1879.5,705C 1878.21,705.49 1876.87,705.657 1875.5,705.5C 1875.5,703.833 1875.5,702.167 1875.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1904.5,700.5 C 1908.16,700.35 1909.16,701.85 1907.5,705C 1903.71,705.487 1902.71,703.987 1904.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1989.5,700.5 C 1993.16,700.35 1994.16,701.85 1992.5,705C 1988.71,705.487 1987.71,703.987 1989.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefafb",
    d: "M 2046.5,700.5 C 2050.16,700.35 2051.16,701.85 2049.5,705C 2045.71,705.487 2044.71,703.987 2046.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef9fb",
    d: "M 2074.5,700.5 C 2078.16,700.35 2079.16,701.85 2077.5,705C 2073.71,705.487 2072.71,703.987 2074.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfbfb",
    d: "M 552.5,701.5 C 565.51,700.998 570.677,706.998 568,719.5C 567.215,721.286 566.049,722.786 564.5,724C 540.282,734.609 515.949,744.942 491.5,755C 479.86,757.02 474.027,752.186 474,740.5C 475.031,737.461 476.865,734.961 479.5,733C 503.923,722.449 528.256,711.949 552.5,701.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5b4bd",
    d: "M 1933.5,700.5 C 1933.34,702.153 1932.67,703.486 1931.5,704.5C 1931.23,702.62 1931.9,701.287 1933.5,700.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed5dc",
    d: "M 1397.5,701.5 C 1398.98,703.709 1398.31,705.042 1395.5,705.5C 1395.23,703.62 1395.9,702.287 1397.5,701.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1408.5,707.5 C 1412.16,707.35 1413.16,708.85 1411.5,712C 1410.21,712.49 1408.87,712.657 1407.5,712.5C 1407.37,710.708 1407.7,709.042 1408.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1436.5,707.5 C 1440.16,707.35 1441.16,708.85 1439.5,712C 1435.71,712.487 1434.71,710.987 1436.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1464.5,707.5 C 1468.14,706.737 1469.64,708.07 1469,711.5C 1464.42,713.413 1462.92,712.079 1464.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1493.5,707.5 C 1497.16,707.35 1498.16,708.85 1496.5,712C 1495.21,712.49 1493.87,712.657 1492.5,712.5C 1492.37,710.708 1492.7,709.042 1493.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1521.5,707.5 C 1524.91,707.384 1526.24,709.05 1525.5,712.5C 1521.07,713.078 1519.73,711.411 1521.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1549.5,707.5 C 1553.14,706.737 1554.64,708.07 1554,711.5C 1549.42,713.413 1547.92,712.079 1549.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef7f8",
    d: "M 1578.5,707.5 C 1582.16,707.35 1583.16,708.85 1581.5,712C 1580.21,712.49 1578.87,712.657 1577.5,712.5C 1577.37,710.708 1577.7,709.042 1578.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1606.5,707.5 C 1609.91,707.384 1611.24,709.05 1610.5,712.5C 1606.07,713.078 1604.73,711.411 1606.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1634.5,707.5 C 1638.14,706.737 1639.64,708.07 1639,711.5C 1634.42,713.413 1632.92,712.079 1634.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1663.5,707.5 C 1667.16,707.35 1668.16,708.85 1666.5,712C 1662.71,712.487 1661.71,710.987 1663.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1691.5,707.5 C 1694.91,707.384 1696.24,709.05 1695.5,712.5C 1691.07,713.078 1689.73,711.411 1691.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1720.5,707.5 C 1724.16,707.35 1725.16,708.85 1723.5,712C 1722.21,712.49 1720.87,712.657 1719.5,712.5C 1719.37,710.708 1719.7,709.042 1720.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1748.5,707.5 C 1752.16,707.35 1753.16,708.85 1751.5,712C 1747.71,712.487 1746.71,710.987 1748.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1776.5,707.5 C 1780.14,706.737 1781.64,708.07 1781,711.5C 1776.42,713.413 1774.92,712.079 1776.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1805.5,707.5 C 1809.16,707.35 1810.16,708.85 1808.5,712C 1807.21,712.49 1805.87,712.657 1804.5,712.5C 1804.37,710.708 1804.7,709.042 1805.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1833.5,707.5 C 1836.91,707.384 1838.24,709.05 1837.5,712.5C 1833.07,713.078 1831.73,711.411 1833.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1861.5,707.5 C 1865.14,706.737 1866.64,708.07 1866,711.5C 1861.42,713.413 1859.92,712.079 1861.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1890.5,707.5 C 1894.16,707.35 1895.16,708.85 1893.5,712C 1892.21,712.49 1890.87,712.657 1889.5,712.5C 1889.37,710.708 1889.7,709.042 1890.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1918.5,707.5 C 1921.91,707.384 1923.24,709.05 1922.5,712.5C 1918.07,713.078 1916.73,711.411 1918.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 1975.5,707.5 C 1979.16,707.35 1980.16,708.85 1978.5,712C 1974.71,712.487 1973.71,710.987 1975.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefbfc",
    d: "M 2060.5,707.5 C 2064.16,707.35 2065.16,708.85 2063.5,712C 2059.71,712.487 2058.71,710.987 2060.5,707.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1422.5,714.5 C 1426.16,714.35 1427.16,715.85 1425.5,719C 1424.21,719.49 1422.87,719.657 1421.5,719.5C 1421.37,717.708 1421.7,716.042 1422.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1450.5,714.5 C 1453.91,714.384 1455.24,716.05 1454.5,719.5C 1450.07,720.078 1448.73,718.411 1450.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1507.5,714.5 C 1511.16,714.35 1512.16,715.85 1510.5,719C 1509.21,719.49 1507.87,719.657 1506.5,719.5C 1506.37,717.708 1506.7,716.042 1507.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1535.5,714.5 C 1538.91,714.384 1540.24,716.05 1539.5,719.5C 1535.07,720.078 1533.73,718.411 1535.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1592.5,714.5 C 1595.91,714.384 1597.24,716.05 1596.5,719.5C 1592.07,720.078 1590.73,718.411 1592.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1649.5,714.5 C 1653.16,714.35 1654.16,715.85 1652.5,719C 1651.21,719.49 1649.87,719.657 1648.5,719.5C 1648.37,717.708 1648.7,716.042 1649.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1677.5,714.5 C 1680.91,714.384 1682.24,716.05 1681.5,719.5C 1677.07,720.078 1675.73,718.411 1677.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1734.5,714.5 C 1738.16,714.35 1739.16,715.85 1737.5,719C 1736.21,719.49 1734.87,719.657 1733.5,719.5C 1733.37,717.708 1733.7,716.042 1734.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1762.5,714.5 C 1765.91,714.384 1767.24,716.05 1766.5,719.5C 1762.07,720.078 1760.73,718.411 1762.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1819.5,714.5 C 1823.16,714.35 1824.16,715.85 1822.5,719C 1821.21,719.49 1819.87,719.657 1818.5,719.5C 1818.37,717.708 1818.7,716.042 1819.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1847.5,714.5 C 1850.91,714.384 1852.24,716.05 1851.5,719.5C 1847.07,720.078 1845.73,718.411 1847.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 1904.5,714.5 C 1907.91,714.384 1909.24,716.05 1908.5,719.5C 1904.07,720.078 1902.73,718.411 1904.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef6f8",
    d: "M 1989.5,714.5 C 1992.91,714.384 1994.24,716.05 1993.5,719.5C 1989.07,720.078 1987.73,718.411 1989.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f8",
    d: "M 2046.5,714.5 C 2050.16,714.35 2051.16,715.85 2049.5,719C 2048.21,719.49 2046.87,719.657 2045.5,719.5C 2045.37,717.708 2045.7,716.042 2046.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 2074.5,714.5 C 2077.91,714.384 2079.24,716.05 2078.5,719.5C 2074.07,720.078 2072.73,718.411 2074.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1393.5,714.5 C 1397.14,713.737 1398.64,715.07 1398,718.5C 1393.42,720.413 1391.92,719.079 1393.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1479.5,714.5 C 1483.16,714.35 1484.16,715.85 1482.5,719C 1477.52,719.864 1476.52,718.364 1479.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1564.5,714.5 C 1568.16,714.35 1569.16,715.85 1567.5,719C 1566.21,719.49 1564.87,719.657 1563.5,719.5C 1563.37,717.708 1563.7,716.042 1564.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1620.5,714.5 C 1623.76,714.174 1625.26,715.507 1625,718.5C 1620.42,720.413 1618.92,719.079 1620.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1705.5,714.5 C 1709.14,713.737 1710.64,715.07 1710,718.5C 1705.42,720.413 1703.92,719.079 1705.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1791.5,714.5 C 1795.16,714.35 1796.16,715.85 1794.5,719C 1789.5,719.787 1788.5,718.287 1791.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1876.5,714.5 C 1880.16,714.35 1881.16,715.85 1879.5,719C 1878.21,719.49 1876.87,719.657 1875.5,719.5C 1875.37,717.708 1875.7,716.042 1876.5,714.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1408.5,721.5 C 1412.16,721.35 1413.16,722.85 1411.5,726C 1410.21,726.49 1408.87,726.657 1407.5,726.5C 1407.37,724.708 1407.7,723.042 1408.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1436.5,721.5 C 1439.91,721.384 1441.24,723.05 1440.5,726.5C 1438.83,726.5 1437.17,726.5 1435.5,726.5C 1435.37,724.708 1435.7,723.042 1436.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1464.5,721.5 C 1467.52,721.364 1469.02,722.698 1469,725.5C 1464.42,727.413 1462.92,726.079 1464.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1493.5,721.5 C 1497.16,721.35 1498.16,722.85 1496.5,726C 1495.21,726.49 1493.87,726.657 1492.5,726.5C 1492.37,724.708 1492.7,723.042 1493.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1521.5,721.5 C 1524.91,721.384 1526.24,723.05 1525.5,726.5C 1521.07,727.078 1519.73,725.411 1521.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf2",
    d: "M 1550.5,721.5 C 1553.76,721.726 1554.76,723.226 1553.5,726C 1548.52,726.864 1547.52,725.364 1550.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1578.5,721.5 C 1582.16,721.35 1583.16,722.85 1581.5,726C 1580.21,726.49 1578.87,726.657 1577.5,726.5C 1577.37,724.708 1577.7,723.042 1578.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1606.5,721.5 C 1609.91,721.384 1611.24,723.05 1610.5,726.5C 1606.07,727.078 1604.73,725.411 1606.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1635.5,721.5 C 1639.16,721.35 1640.16,722.85 1638.5,726C 1633.52,726.864 1632.52,725.364 1635.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1663.5,721.5 C 1666.91,721.384 1668.24,723.05 1667.5,726.5C 1665.83,726.5 1664.17,726.5 1662.5,726.5C 1662.37,724.708 1662.7,723.042 1663.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1691.5,721.5 C 1694.91,721.384 1696.24,723.05 1695.5,726.5C 1691.07,727.078 1689.73,725.411 1691.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1720.5,721.5 C 1724.16,721.35 1725.16,722.85 1723.5,726C 1722.21,726.49 1720.87,726.657 1719.5,726.5C 1719.37,724.708 1719.7,723.042 1720.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1748.5,721.5 C 1751.91,721.384 1753.24,723.05 1752.5,726.5C 1750.83,726.5 1749.17,726.5 1747.5,726.5C 1747.37,724.708 1747.7,723.042 1748.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1776.5,721.5 C 1779.52,721.364 1781.02,722.698 1781,725.5C 1776.42,727.413 1774.92,726.079 1776.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1805.5,721.5 C 1809.16,721.35 1810.16,722.85 1808.5,726C 1807.21,726.49 1805.87,726.657 1804.5,726.5C 1804.37,724.708 1804.7,723.042 1805.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1833.5,721.5 C 1836.91,721.384 1838.24,723.05 1837.5,726.5C 1833.07,727.078 1831.73,725.411 1833.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee9ee",
    d: "M 1861.5,721.5 C 1864.73,721.165 1866.23,722.498 1866,725.5C 1861.42,727.413 1859.92,726.079 1861.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef5f7",
    d: "M 1890.5,721.5 C 1894.16,721.35 1895.16,722.85 1893.5,726C 1892.21,726.49 1890.87,726.657 1889.5,726.5C 1889.37,724.708 1889.7,723.042 1890.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef4f7",
    d: "M 1918.5,721.5 C 1921.91,721.384 1923.24,723.05 1922.5,726.5C 1918.07,727.078 1916.73,725.411 1918.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f5",
    d: "M 1975.5,721.5 C 1978.91,721.384 1980.24,723.05 1979.5,726.5C 1977.83,726.5 1976.17,726.5 1974.5,726.5C 1974.37,724.708 1974.7,723.042 1975.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 2060.5,721.5 C 2063.91,721.384 2065.24,723.05 2064.5,726.5C 2062.83,726.5 2061.17,726.5 2059.5,726.5C 2059.37,724.708 2059.7,723.042 2060.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8d2d8",
    d: "M 2090.5,721.5 C 2091.15,723.435 2091.48,725.435 2091.5,727.5C 2086.78,726.085 2086.44,724.085 2090.5,721.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebe0e3",
    d: "M 2035.5,722.5 C 2037.03,725.33 2036.03,726.663 2032.5,726.5C 2033.03,724.77 2034.03,723.436 2035.5,722.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcbfc7",
    d: "M 2002.5,723.5 C 2004.17,724.5 2005.5,725.833 2006.5,727.5C 2004.17,727.167 2002.83,725.833 2002.5,723.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1394.5,728.5 C 1399.2,729.874 1399.53,731.874 1395.5,734.5C 1392.03,732.916 1391.69,730.916 1394.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1422.5,728.5 C 1426.35,728.701 1427.35,730.534 1425.5,734C 1421.54,734.118 1420.54,732.284 1422.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1450.5,728.5 C 1454.07,728.408 1455.24,730.074 1454,733.5C 1451.69,734.582 1450.19,733.748 1449.5,731C 1449.74,730.098 1450.08,729.265 1450.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee6ec",
    d: "M 1479.5,728.5 C 1484.39,729.54 1484.73,731.54 1480.5,734.5C 1477.03,732.916 1476.69,730.916 1479.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1507.5,728.5 C 1511.35,728.701 1512.35,730.534 1510.5,734C 1506.54,734.118 1505.54,732.284 1507.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1535.5,728.5 C 1539.07,728.408 1540.24,730.074 1539,733.5C 1536.69,734.582 1535.19,733.748 1534.5,731C 1534.74,730.098 1535.08,729.265 1535.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1564.5,728.5 C 1569.39,729.54 1569.73,731.54 1565.5,734.5C 1563.26,732.867 1562.93,730.867 1564.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1592.5,728.5 C 1596.35,728.701 1597.35,730.534 1595.5,734C 1591.54,734.118 1590.54,732.284 1592.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1621.5,728.5 C 1626.2,729.874 1626.53,731.874 1622.5,734.5C 1619.03,732.916 1618.69,730.916 1621.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf2",
    d: "M 1649.5,728.5 C 1654.39,729.54 1654.73,731.54 1650.5,734.5C 1648.26,732.867 1647.93,730.867 1649.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1677.5,728.5 C 1681.35,728.701 1682.35,730.534 1680.5,734C 1676.54,734.118 1675.54,732.284 1677.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1706.5,728.5 C 1711.2,729.874 1711.53,731.874 1707.5,734.5C 1704.03,732.916 1703.69,730.916 1706.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1734.5,728.5 C 1738.35,728.701 1739.35,730.534 1737.5,734C 1733.54,734.118 1732.54,732.284 1734.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1762.5,728.5 C 1766.07,728.408 1767.24,730.074 1766,733.5C 1763.69,734.582 1762.19,733.748 1761.5,731C 1761.74,730.098 1762.08,729.265 1762.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1791.5,728.5 C 1796.2,729.874 1796.53,731.874 1792.5,734.5C 1789.03,732.916 1788.69,730.916 1791.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1819.5,728.5 C 1823.35,728.701 1824.35,730.534 1822.5,734C 1818.54,734.118 1817.54,732.284 1819.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1847.5,728.5 C 1851.07,728.408 1852.24,730.074 1851,733.5C 1848.69,734.582 1847.19,733.748 1846.5,731C 1846.74,730.098 1847.08,729.265 1847.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1876.5,728.5 C 1881.39,729.54 1881.73,731.54 1877.5,734.5C 1875.26,732.867 1874.93,730.867 1876.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde8ee",
    d: "M 1904.5,728.5 C 1908.35,728.701 1909.35,730.534 1907.5,734C 1903.54,734.118 1902.54,732.284 1904.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1932.5,728.5 C 1937.89,729.25 1938.56,731.25 1934.5,734.5C 1931.51,733.205 1930.85,731.205 1932.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1961.5,728.5 C 1966.39,729.54 1966.73,731.54 1962.5,734.5C 1960.26,732.867 1959.93,730.867 1961.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1989.5,728.5 C 1993.35,728.701 1994.35,730.534 1992.5,734C 1988.54,734.118 1987.54,732.284 1989.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 2046.5,728.5 C 2051.16,729.324 2051.66,731.324 2048,734.5C 2045.33,733.142 2044.83,731.142 2046.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 2074.5,728.5 C 2078.35,728.701 2079.35,730.534 2077.5,734C 2073.83,733.836 2072.83,732.003 2074.5,728.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fce6ec",
    d: "M 2016.5,731.5 C 2018.5,731.5 2020.5,731.5 2022.5,731.5C 2020.5,735.5 2018.5,735.5 2016.5,731.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1408.5,735.5 C 1412.35,735.701 1413.35,737.534 1411.5,741C 1407.54,741.118 1406.54,739.284 1408.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde8ee",
    d: "M 1436.5,735.5 C 1440.35,735.701 1441.35,737.534 1439.5,741C 1435.54,741.118 1434.54,739.284 1436.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1465.5,735.5 C 1470.2,736.874 1470.53,738.874 1466.5,741.5C 1463.03,739.916 1462.69,737.916 1465.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1493.5,735.5 C 1497.35,735.701 1498.35,737.534 1496.5,741C 1492.54,741.118 1491.54,739.284 1493.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1521.5,735.5 C 1525.35,735.701 1526.35,737.534 1524.5,741C 1520.54,741.118 1519.54,739.284 1521.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdeaef",
    d: "M 1550.5,735.5 C 1555.2,736.874 1555.53,738.874 1551.5,741.5C 1548.03,739.916 1547.69,737.916 1550.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1578.5,735.5 C 1582.35,735.701 1583.35,737.534 1581.5,741C 1577.54,741.118 1576.54,739.284 1578.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeff3",
    d: "M 1607.5,735.5 C 1609.48,735.484 1610.48,736.484 1610.5,738.5C 1609.14,742.362 1607.47,742.362 1605.5,738.5C 1606.19,737.482 1606.86,736.482 1607.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1635.5,735.5 C 1640.2,736.874 1640.53,738.874 1636.5,741.5C 1633.03,739.916 1632.69,737.916 1635.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1663.5,735.5 C 1667.35,735.701 1668.35,737.534 1666.5,741C 1662.54,741.118 1661.54,739.284 1663.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef0f4",
    d: "M 1692.5,735.5 C 1694.48,735.484 1695.48,736.484 1695.5,738.5C 1694.14,742.362 1692.47,742.362 1690.5,738.5C 1691.19,737.482 1691.86,736.482 1692.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1720.5,735.5 C 1724.35,735.701 1725.35,737.534 1723.5,741C 1719.54,741.118 1718.54,739.284 1720.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1748.5,735.5 C 1752.35,735.701 1753.35,737.534 1751.5,741C 1747.54,741.118 1746.54,739.284 1748.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1777.5,735.5 C 1782.2,736.874 1782.53,738.874 1778.5,741.5C 1775.03,739.916 1774.69,737.916 1777.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1805.5,735.5 C 1809.35,735.701 1810.35,737.534 1808.5,741C 1804.54,741.118 1803.54,739.284 1805.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1833.5,735.5 C 1837.35,735.701 1838.35,737.534 1836.5,741C 1832.54,741.118 1831.54,739.284 1833.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 1862.5,735.5 C 1867.2,736.874 1867.53,738.874 1863.5,741.5C 1860.03,739.916 1859.69,737.916 1862.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 1890.5,735.5 C 1894.35,735.701 1895.35,737.534 1893.5,741C 1889.54,741.118 1888.54,739.284 1890.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1918.5,735.5 C 1922.35,735.701 1923.35,737.534 1921.5,741C 1917.54,741.118 1916.54,739.284 1918.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef0f4",
    d: "M 1947.5,735.5 C 1952.2,736.874 1952.53,738.874 1948.5,741.5C 1946.26,739.867 1945.93,737.867 1947.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fde8ee",
    d: "M 1975.5,735.5 C 1979.35,735.701 1980.35,737.534 1978.5,741C 1974.54,741.118 1973.54,739.284 1975.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee9ef",
    d: "M 2004.5,735.5 C 2009.2,736.874 2009.53,738.874 2005.5,741.5C 2002.03,739.916 2001.69,737.916 2004.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feeaef",
    d: "M 2032.5,735.5 C 2037.2,736.874 2037.53,738.874 2033.5,741.5C 2030.03,739.916 2029.69,737.916 2032.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee7ed",
    d: "M 2060.5,735.5 C 2064.35,735.701 2065.35,737.534 2063.5,741C 2059.54,741.118 2058.54,739.284 2060.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf2",
    d: "M 2091.5,735.5 C 2091.5,737.5 2091.5,739.5 2091.5,741.5C 2086.17,739.5 2086.17,737.5 2091.5,735.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1394.5,742.5 C 1399.2,743.874 1399.53,745.874 1395.5,748.5C 1392.03,746.916 1391.69,744.916 1394.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef0f3",
    d: "M 1421.5,743.5 C 1423.17,743.5 1424.83,743.5 1426.5,743.5C 1427.17,747.676 1425.67,749.009 1422,747.5C 1421.51,746.207 1421.34,744.873 1421.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1451.5,742.5 C 1453.48,742.484 1454.48,743.484 1454.5,745.5C 1454.57,747.266 1453.73,748.266 1452,748.5C 1448.9,746.888 1448.73,744.888 1451.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee6ec",
    d: "M 1479.5,742.5 C 1482.97,743.109 1483.97,744.942 1482.5,748C 1477.72,748.073 1476.72,746.24 1479.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1507.5,742.5 C 1511.35,742.701 1512.35,744.534 1510.5,748C 1506.54,748.118 1505.54,746.284 1507.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee6ec",
    d: "M 1536.5,742.5 C 1541.51,744.163 1541.67,746.163 1537,748.5C 1533.9,746.888 1533.73,744.888 1536.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf0",
    d: "M 1564.5,742.5 C 1567.97,743.109 1568.97,744.942 1567.5,748C 1563.54,748.118 1562.54,746.284 1564.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1592.5,742.5 C 1596.35,742.701 1597.35,744.534 1595.5,748C 1591.54,748.118 1590.54,746.284 1592.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1621.5,742.5 C 1626.2,743.874 1626.53,745.874 1622.5,748.5C 1618.87,747.059 1618.53,745.059 1621.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef3f6",
    d: "M 1648.5,743.5 C 1652.14,742.737 1653.64,744.07 1653,747.5C 1649.33,749.009 1647.83,747.676 1648.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f4",
    d: "M 1676.5,743.5 C 1678.17,743.5 1679.83,743.5 1681.5,743.5C 1682.17,747.676 1680.67,749.009 1677,747.5C 1676.51,746.207 1676.34,744.873 1676.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1706.5,742.5 C 1711.2,743.874 1711.53,745.874 1707.5,748.5C 1704.03,746.916 1703.69,744.916 1706.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef1f4",
    d: "M 1733.5,743.5 C 1735.17,743.5 1736.83,743.5 1738.5,743.5C 1739.17,747.676 1737.67,749.009 1734,747.5C 1733.51,746.207 1733.34,744.873 1733.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1763.5,742.5 C 1765.48,742.484 1766.48,743.484 1766.5,745.5C 1766.57,747.266 1765.73,748.266 1764,748.5C 1760.9,746.888 1760.73,744.888 1763.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1791.5,742.5 C 1796.2,743.874 1796.53,745.874 1792.5,748.5C 1789.03,746.916 1788.69,744.916 1791.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1819.5,742.5 C 1823.35,742.701 1824.35,744.534 1822.5,748C 1818.54,748.118 1817.54,746.284 1819.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feecf1",
    d: "M 1848.5,742.5 C 1850.48,742.484 1851.48,743.484 1851.5,745.5C 1851.57,747.266 1850.73,748.266 1849,748.5C 1845.9,746.888 1845.73,744.888 1848.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 1876.5,742.5 C 1879.97,743.109 1880.97,744.942 1879.5,748C 1875.54,748.118 1874.54,746.284 1876.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ee",
    d: "M 1904.5,742.5 C 1908.35,742.701 1909.35,744.534 1907.5,748C 1903.54,748.118 1902.54,746.284 1904.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee6ec",
    d: "M 1933.5,742.5 C 1938.51,744.163 1938.67,746.163 1934,748.5C 1930.9,746.888 1930.73,744.888 1933.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feedf1",
    d: "M 1961.5,742.5 C 1964.97,743.109 1965.97,744.942 1964.5,748C 1960.54,748.118 1959.54,746.284 1961.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fee8ed",
    d: "M 1989.5,742.5 C 1993.35,742.701 1994.35,744.534 1992.5,748C 1988.54,748.118 1987.54,746.284 1989.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#feebf0",
    d: "M 2018.5,742.5 C 2023.2,743.874 2023.53,745.874 2019.5,748.5C 2016.03,746.916 2015.69,744.916 2018.5,742.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 2045.5,743.5 C 2049.14,742.737 2050.64,744.07 2050,747.5C 2046.33,749.009 2044.83,747.676 2045.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fef2f5",
    d: "M 2074.5,743.5 C 2075.83,743.5 2077.17,743.5 2078.5,743.5C 2078.99,745.948 2078.16,747.615 2076,748.5C 2073.39,747.5 2072.89,745.833 2074.5,743.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#924459",
    d: "M 1389.5,726.5 C 1389.5,734.5 1389.5,742.5 1389.5,750.5C 1623.5,750.5 1857.5,750.5 2091.5,750.5C 1857.33,751.5 1623,751.833 1388.5,751.5C 1388.17,742.983 1388.51,734.65 1389.5,726.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 1388.5,757.5 C 1622.83,757.5 1857.17,757.5 2091.5,757.5C 2091.67,879.5 2091.5,1001.5 2091,1123.5C 2085.21,1154.95 2066.38,1172.12 2034.5,1175C 1837.5,1175.67 1640.5,1175.67 1443.5,1175C 1411.2,1170.37 1393.04,1151.87 1389,1119.5C 1388.5,998.834 1388.33,878.167 1388.5,757.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#231f20",
    d: "M 328.5,810.5 C 345.813,812.312 352.313,821.645 348,838.5C 339.028,850.877 328.361,852.544 316,843.5C 307.115,827.302 311.282,816.302 328.5,810.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3d85f",
    d: "M 326.5,820.5 C 334.125,819.469 338.792,822.636 340.5,830C 339.824,836.259 336.324,839.426 330,839.5C 323.142,838.467 320.142,834.467 321,827.5C 321.967,824.379 323.8,822.046 326.5,820.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#231f20",
    d: "M 2375.5,843.5 C 2385.94,842.627 2393.1,846.96 2397,856.5C 2397.67,920.5 2397.67,984.5 2397,1048.5C 2391.41,1061.04 2382.24,1064.54 2369.5,1059C 2366.24,1056.41 2363.74,1053.24 2362,1049.5C 2361.33,985.167 2361.33,920.833 2362,856.5C 2364.44,849.888 2368.94,845.555 2375.5,843.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e0",
    d: "M 606.5,849.5 C 606.5,907.5 606.5,965.5 606.5,1023.5C 608.167,1023.5 609.833,1023.5 611.5,1023.5C 609.735,1024.46 607.735,1024.79 605.5,1024.5C 605.168,965.998 605.501,907.664 606.5,849.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2abf0",
    d: "M 596.5,853.5 C 597.499,910.331 597.832,967.331 597.5,1024.5C 573.833,1024.5 550.167,1024.5 526.5,1024.5C 526.5,976.833 526.5,929.167 526.5,881.5C 528.199,881.66 529.866,881.494 531.5,881C 553.155,871.729 574.822,862.562 596.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#403845",
    d: "M 596.5,853.5 C 596.56,852.957 596.893,852.624 597.5,852.5C 598.831,909.999 598.831,967.332 597.5,1024.5C 597.832,967.331 597.499,910.331 596.5,853.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7147ec",
    d: "M 2376.5,852.5 C 2381.55,852.274 2385.38,854.274 2388,858.5C 2388.67,921.167 2388.67,983.833 2388,1046.5C 2384.96,1052.37 2380.46,1053.87 2374.5,1051C 2372.95,1049.79 2371.78,1048.29 2371,1046.5C 2370.33,983.833 2370.33,921.167 2371,858.5C 2372.36,855.977 2374.19,853.977 2376.5,852.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#252222",
    d: "M 1880.5,866.5 C 1883.85,866.335 1887.18,866.502 1890.5,867C 1903,879.5 1915.5,892 1928,904.5C 1928.67,908.5 1928.67,912.5 1928,916.5C 1865.19,978.306 1802.69,1040.47 1740.5,1103C 1737.17,1103.67 1733.83,1103.67 1730.5,1103C 1697.08,1069.58 1663.58,1036.08 1630,1002.5C 1629.33,999.167 1629.33,995.833 1630,992.5C 1641.83,980.667 1653.67,968.833 1665.5,957C 1669.17,956.333 1672.83,956.333 1676.5,957C 1695.33,975.833 1714.17,994.667 1733,1013.5C 1782.06,964.272 1831.23,915.272 1880.5,866.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8de61",
    d: "M 1884.5,880.5 C 1894.47,889.964 1904.3,899.631 1914,909.5C 1914.67,910.167 1914.67,910.833 1914,911.5C 1854.64,971.194 1794.97,1030.53 1735,1089.5C 1705.01,1058.68 1674.85,1028.01 1644.5,997.5C 1653.15,988.348 1661.99,979.348 1671,970.5C 1689.86,989.695 1709.03,1008.53 1728.5,1027C 1731.83,1027.67 1735.17,1027.67 1738.5,1027C 1787.37,978.299 1836.03,929.465 1884.5,880.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 717.5,1020.5 C 716.596,1021.21 716.263,1022.21 716.5,1023.5C 685.167,1023.5 653.833,1023.5 622.5,1023.5C 622.5,1021.83 622.5,1020.17 622.5,1018.5C 623.047,988.552 628.547,959.552 639,931.5C 643.288,922.417 648.454,913.917 654.5,906C 667.204,895.161 681.537,892.495 697.5,898C 702.893,900.726 707.726,904.226 712,908.5C 719.851,919.702 725.685,931.869 729.5,945C 723.693,960.637 720.193,976.803 719,993.5C 718.12,1002.48 717.62,1011.48 717.5,1020.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfd",
    d: "M 781.5,896.5 C 795.752,895.969 807.918,900.636 818,910.5C 828.632,926.71 835.965,944.377 840,963.5C 844.321,983.606 846.488,1003.94 846.5,1024.5C 814.927,1024.83 783.427,1024.5 752,1023.5C 751.52,997.985 747.853,972.985 741,948.5C 740.39,942.262 741.39,936.262 744,930.5C 747.667,924.167 751.333,917.833 755,911.5C 762.218,903.479 771.051,898.479 781.5,896.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4f4",
    d: "M 741.5,1019.5 C 741.5,1020.83 741.5,1022.17 741.5,1023.5C 736.833,1023.5 732.167,1023.5 727.5,1023.5C 727.5,1021.17 727.5,1018.83 727.5,1016.5C 727.967,998.232 730.3,980.232 734.5,962.5C 738.881,981.218 741.215,1000.22 741.5,1019.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#999798",
    d: "M 622.5,1018.5 C 622.5,1020.17 622.5,1021.83 622.5,1023.5C 653.833,1023.5 685.167,1023.5 716.5,1023.5C 716.263,1022.21 716.596,1021.21 717.5,1020.5C 717.5,1021.83 717.5,1023.17 717.5,1024.5C 685.5,1024.5 653.5,1024.5 621.5,1024.5C 621.205,1022.26 621.539,1020.26 622.5,1018.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878586",
    d: "M 727.5,1016.5 C 727.5,1018.83 727.5,1021.17 727.5,1023.5C 732.167,1023.5 736.833,1023.5 741.5,1023.5C 741.5,1022.17 741.5,1020.83 741.5,1019.5C 742.451,1020.92 742.784,1022.59 742.5,1024.5C 737.167,1024.5 731.833,1024.5 726.5,1024.5C 726.194,1021.61 726.527,1018.95 727.5,1016.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b1b2",
    d: "M 856.5,1018.5 C 857.451,1019.92 857.784,1021.59 857.5,1023.5C 892.004,1023.17 926.337,1023.5 960.5,1024.5C 925.833,1024.5 891.167,1024.5 856.5,1024.5C 856.5,1022.5 856.5,1020.5 856.5,1018.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3b6a5",
    d: "M 497.5,1034.5 C 527.5,1034.5 557.5,1034.5 587.5,1034.5C 587.833,1188.5 587.5,1342.5 586.5,1496.5C 556.517,1523.32 526.684,1550.32 497,1577.5C 497.368,1396.5 497.534,1215.5 497.5,1034.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7147ed",
    d: "M 597.5,1034.5 C 625.167,1034.5 652.833,1034.5 680.5,1034.5C 681.67,1197.83 683.004,1361.17 684.5,1524.5C 684.167,1545.5 683.833,1566.5 683.5,1587.5C 654.849,1560.68 626.349,1533.68 598,1506.5C 597.5,1349.17 597.333,1191.83 597.5,1034.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7349ed",
    d: "M 962.5,1218.5 C 960.938,1220.9 961.271,1222.9 963.5,1224.5C 963.5,1229.17 963.5,1233.83 963.5,1238.5C 960.738,1241.15 961.071,1243.48 964.5,1245.5C 964.5,1249.83 964.5,1254.17 964.5,1258.5C 962.516,1258.48 961.516,1259.48 961.5,1261.5C 961.754,1263.42 962.754,1264.75 964.5,1265.5C 965.485,1269.63 965.818,1273.97 965.5,1278.5C 960.167,1280.83 960.167,1283.17 965.5,1285.5C 965.769,1289.93 965.436,1294.26 964.5,1298.5C 960.368,1302.13 961.035,1304.8 966.5,1306.5C 966.5,1310.5 966.5,1314.5 966.5,1318.5C 961.332,1319.34 960.332,1321.84 963.5,1326C 964.793,1326.49 966.127,1326.66 967.5,1326.5C 967.5,1330.5 967.5,1334.5 967.5,1338.5C 961.512,1338.66 960.179,1341.16 963.5,1346C 965.066,1346.76 966.399,1346.6 967.5,1345.5C 968.486,1349.97 968.819,1354.64 968.5,1359.5C 964.92,1357.64 962.586,1358.64 961.5,1362.5C 962.586,1366.36 964.92,1367.36 968.5,1365.5C 968.819,1370.36 968.486,1375.03 967.5,1379.5C 963.491,1379.01 961.658,1380.68 962,1384.5C 964.494,1387.09 966.994,1387.09 969.5,1384.5C 972.733,1453.48 975.733,1522.48 978.5,1591.5C 920.825,1591.44 863.159,1590.78 805.5,1589.5C 805.5,1589.17 805.5,1588.83 805.5,1588.5C 807.441,1586.99 807.941,1584.99 807,1582.5C 801.846,1580.18 799.679,1581.84 800.5,1587.5C 789.012,1588.49 777.345,1588.83 765.5,1588.5C 768.377,1583.03 766.71,1581.03 760.5,1582.5C 759.15,1584.78 759.483,1586.78 761.5,1588.5C 749.5,1588.5 737.5,1588.5 725.5,1588.5C 727.927,1582.43 726.094,1580.43 720,1582.5C 719.322,1584.6 719.489,1586.6 720.5,1588.5C 711.915,1588.82 703.415,1588.48 695,1587.5C 693.247,1403.17 691.747,1218.84 690.5,1034.5C 779.167,1034.5 867.833,1034.5 956.5,1034.5C 958.606,1095.91 960.606,1157.24 962.5,1218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1035.5 C 724.352,1035.35 726.019,1036.69 726.5,1039.5C 724.167,1044.83 721.833,1044.83 719.5,1039.5C 719.752,1037.93 720.418,1036.59 721.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 761.5,1035.5 C 767.488,1035.66 768.821,1038.16 765.5,1043C 759.403,1043.15 758.07,1040.65 761.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 802.5,1035.5 C 805.352,1035.35 807.019,1036.69 807.5,1039.5C 805.054,1044.71 802.387,1044.71 799.5,1039.5C 800.172,1037.84 801.172,1036.51 802.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee9fd",
    d: "M 842.5,1035.5 C 848.488,1035.66 849.821,1038.16 846.5,1043C 840.403,1043.15 839.07,1040.65 842.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1035.5 C 888.488,1035.66 889.821,1038.16 886.5,1043C 880.403,1043.15 879.07,1040.65 882.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 923.5,1035.5 C 927.979,1035.9 929.312,1038.23 927.5,1042.5C 924.208,1044.18 922.208,1043.18 921.5,1039.5C 921.752,1037.93 922.418,1036.59 923.5,1035.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 701.5,1045.5 C 706.668,1046.34 707.668,1048.84 704.5,1053C 697.934,1052.81 696.934,1050.31 701.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 741.5,1045.5 C 747.02,1046.04 748.354,1048.54 745.5,1053C 739.403,1053.15 738.07,1050.65 741.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 781.5,1045.5 C 787.488,1045.66 788.821,1048.16 785.5,1053C 779.403,1053.15 778.07,1050.65 781.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f4fe",
    d: "M 822.5,1045.5 C 827.181,1045.88 828.515,1048.21 826.5,1052.5C 823.208,1054.18 821.208,1053.18 820.5,1049.5C 820.752,1047.93 821.418,1046.59 822.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 862.5,1045.5 C 868.488,1045.66 869.821,1048.16 866.5,1053C 860.403,1053.15 859.07,1050.65 862.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 943.5,1045.5 C 949.02,1046.04 950.354,1048.54 947.5,1053C 941.403,1053.15 940.07,1050.65 943.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 903.5,1045.5 C 908.668,1046.34 909.668,1048.84 906.5,1053C 901.917,1053.93 900.417,1052.1 902,1047.5C 902.717,1046.96 903.217,1046.29 903.5,1045.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 721.5,1055.5 C 726.262,1056.09 727.596,1058.59 725.5,1063C 719.202,1063.5 717.868,1061 721.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeafd",
    d: "M 761.5,1055.5 C 767.488,1055.66 768.821,1058.16 765.5,1063C 759.403,1063.15 758.07,1060.65 761.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f0fd",
    d: "M 802.5,1055.5 C 807.668,1056.34 808.668,1058.84 805.5,1063C 800.917,1063.93 799.417,1062.1 801,1057.5C 801.717,1056.96 802.217,1056.29 802.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1055.5 C 847.805,1056.24 849.139,1058.74 846.5,1063C 840.403,1063.15 839.07,1060.65 842.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 883.5,1055.5 C 888.668,1056.34 889.668,1058.84 886.5,1063C 879.934,1062.81 878.934,1060.31 883.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1055.5 C 928.262,1056.09 929.596,1058.59 927.5,1063C 924.402,1064.07 922.402,1063.07 921.5,1060C 921.519,1058.17 922.185,1056.67 923.5,1055.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4effd",
    d: "M 701.5,1065.5 C 706.668,1066.34 707.668,1068.84 704.5,1073C 697.951,1072.86 696.951,1070.36 701.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 741.5,1065.5 C 746.805,1066.24 748.139,1068.74 745.5,1073C 739.403,1073.15 738.07,1070.65 741.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 781.5,1066.5 C 787.555,1065.94 788.888,1068.11 785.5,1073C 779.738,1073.42 778.404,1071.25 781.5,1066.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 822.5,1065.5 C 827.262,1066.09 828.596,1068.59 826.5,1073C 820.202,1073.5 818.868,1071 822.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 863.5,1065.5 C 868.328,1066.64 869.328,1069.14 866.5,1073C 862,1073.83 860.167,1072 861,1067.5C 861.995,1066.93 862.828,1066.27 863.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 903.5,1065.5 C 908.262,1066.09 909.596,1068.59 907.5,1073C 901.202,1073.5 899.868,1071 903.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 943.5,1065.5 C 948.805,1066.24 950.139,1068.74 947.5,1073C 941.403,1073.15 940.07,1070.65 943.5,1065.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 720.5,1076.5 C 726.158,1075.68 727.825,1077.85 725.5,1083C 719.741,1084.14 718.074,1081.97 720.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 760.5,1076.5 C 765.006,1075.53 767.172,1077.19 767,1081.5C 763.813,1084.41 761.313,1083.91 759.5,1080C 759.989,1078.86 760.322,1077.69 760.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 801.5,1076.5 C 807.158,1075.68 808.825,1077.85 806.5,1083C 800.741,1084.14 799.074,1081.97 801.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 841.5,1076.5 C 846.006,1075.53 848.172,1077.19 848,1081.5C 846.116,1083.58 843.949,1083.91 841.5,1082.5C 840.181,1080.47 840.181,1078.47 841.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1076.5 C 887.894,1075.55 889.561,1077.55 887.5,1082.5C 881.29,1083.97 879.623,1081.97 882.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1076.5 C 928.158,1075.68 929.825,1077.85 927.5,1083C 921.741,1084.14 920.074,1081.97 922.5,1076.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 700.5,1086.5 C 706.158,1085.68 707.825,1087.85 705.5,1093C 699.244,1093.93 697.577,1091.77 700.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 740.5,1086.5 C 745.006,1085.53 747.172,1087.19 747,1091.5C 740.645,1095.2 738.478,1093.53 740.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 781.5,1086.5 C 786.52,1085.91 788.186,1087.91 786.5,1092.5C 780.29,1093.97 778.623,1091.97 781.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 862.5,1086.5 C 868.016,1086.47 869.349,1088.64 866.5,1093C 860.738,1093.42 859.404,1091.25 862.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 902.5,1086.5 C 908.158,1085.68 909.825,1087.85 907.5,1093C 901.244,1093.93 899.577,1091.77 902.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 942.5,1086.5 C 947.006,1085.53 949.172,1087.19 949,1091.5C 947.116,1093.58 944.949,1093.91 942.5,1092.5C 941.181,1090.47 941.181,1088.47 942.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 821.5,1086.5 C 827.158,1085.68 828.825,1087.85 826.5,1093C 820.741,1094.14 819.074,1091.97 821.5,1086.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 720.5,1096.5 C 726.704,1096.31 728.037,1098.81 724.5,1104C 719.632,1103.71 718.299,1101.21 720.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 801.5,1096.5 C 807.704,1096.31 809.037,1098.81 805.5,1104C 800.632,1103.71 799.299,1101.21 801.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 842.5,1096.5 C 848.016,1096.47 849.349,1098.64 846.5,1103C 840.339,1103.88 839.006,1101.71 842.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 882.5,1096.5 C 887.486,1096.3 889.152,1098.47 887.5,1103C 881.244,1103.93 879.577,1101.77 882.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 922.5,1096.5 C 928.704,1096.31 930.037,1098.81 926.5,1104C 921.632,1103.71 920.299,1101.21 922.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 761.5,1096.5 C 768.513,1097.54 769.18,1100.21 763.5,1104.5C 759.302,1102.59 758.635,1099.92 761.5,1096.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1106.5 C 706.488,1106.66 707.821,1109.16 704.5,1114C 698.95,1113.63 697.617,1111.13 700.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 741.5,1106.5 C 744.571,1105.92 746.571,1107.09 747.5,1110C 744.859,1115.63 742.192,1115.8 739.5,1110.5C 739.752,1108.93 740.418,1107.59 741.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 781.5,1106.5 C 787.488,1106.66 788.821,1109.16 785.5,1114C 779.812,1113.79 778.479,1111.29 781.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 821.5,1106.5 C 827.704,1106.31 829.037,1108.81 825.5,1114C 820.632,1113.71 819.299,1111.21 821.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f2fd",
    d: "M 862.5,1106.5 C 867.486,1106.3 869.152,1108.47 867.5,1113C 860.561,1114.57 858.894,1112.41 862.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f4fe",
    d: "M 902.5,1106.5 C 908.488,1106.66 909.821,1109.16 906.5,1114C 901.632,1113.71 900.299,1111.21 902.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 943.5,1106.5 C 946.571,1105.92 948.571,1107.09 949.5,1110C 946.859,1115.63 944.192,1115.8 941.5,1110.5C 941.752,1108.93 942.418,1107.59 943.5,1106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#241f20",
    d: "M 2184.5,1111.5 C 2200.3,1112.42 2207.13,1120.75 2205,1136.5C 2198.57,1148.79 2189.07,1151.95 2176.5,1146C 2167.27,1137.54 2166.1,1128.04 2173,1117.5C 2176.37,1114.44 2180.21,1112.44 2184.5,1111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 761.5,1116.5 C 767.488,1116.66 768.821,1119.16 765.5,1124C 759.403,1124.15 758.07,1121.65 761.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 882.5,1116.5 C 888.488,1116.66 889.821,1119.16 886.5,1124C 880.812,1123.79 879.479,1121.29 882.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 721.5,1116.5 C 725.605,1116.5 727.105,1118.5 726,1122.5C 722.509,1125.45 720.342,1124.61 719.5,1120C 719.862,1118.57 720.528,1117.4 721.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 801.5,1116.5 C 807.488,1116.66 808.821,1119.16 805.5,1124C 800.632,1123.71 799.299,1121.21 801.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1116.5 C 847.214,1116.2 848.88,1118.2 847.5,1122.5C 844.123,1125.49 841.79,1124.82 840.5,1120.5C 840.752,1118.93 841.418,1117.59 842.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 923.5,1116.5 C 928.068,1116.08 929.568,1118.08 928,1122.5C 924.828,1125.39 922.661,1124.72 921.5,1120.5C 921.752,1118.93 922.418,1117.59 923.5,1116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c4d95f",
    d: "M 2182.5,1121.5 C 2191.95,1120.12 2196.45,1124.12 2196,1133.5C 2193.37,1138.73 2189.2,1140.56 2183.5,1139C 2175.87,1133.67 2175.53,1127.83 2182.5,1121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1126.5 C 706.488,1126.66 707.821,1129.16 704.5,1134C 698.812,1133.79 697.479,1131.29 700.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 741.5,1126.5 C 746.214,1126.2 747.88,1128.2 746.5,1132.5C 743.123,1135.49 740.79,1134.82 739.5,1130.5C 739.752,1128.93 740.418,1127.59 741.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1126.5 C 787.488,1126.66 788.821,1129.16 785.5,1134C 779.403,1134.15 778.07,1131.65 781.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1126.5 C 826.605,1126.5 828.105,1128.5 827,1132.5C 823.828,1135.39 821.661,1134.72 820.5,1130.5C 820.752,1128.93 821.418,1127.59 822.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 862.5,1126.5 C 868.488,1126.66 869.821,1129.16 866.5,1134C 860.403,1134.15 859.07,1131.65 862.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f5fe",
    d: "M 902.5,1126.5 C 908.488,1126.66 909.821,1129.16 906.5,1134C 901.632,1133.71 900.299,1131.21 902.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 943.5,1126.5 C 949.488,1126.66 950.821,1129.16 947.5,1134C 941.403,1134.15 940.07,1131.65 943.5,1126.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1136.5 C 724.352,1136.35 726.019,1137.69 726.5,1140.5C 724.167,1145.83 721.833,1145.83 719.5,1140.5C 719.752,1138.93 720.418,1137.59 721.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 761.5,1136.5 C 767.488,1136.66 768.821,1139.16 765.5,1144C 759.403,1144.15 758.07,1141.65 761.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 802.5,1136.5 C 805.352,1136.35 807.019,1137.69 807.5,1140.5C 805.054,1145.71 802.387,1145.71 799.5,1140.5C 800.172,1138.84 801.172,1137.51 802.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee9fd",
    d: "M 842.5,1136.5 C 848.488,1136.66 849.821,1139.16 846.5,1144C 840.403,1144.15 839.07,1141.65 842.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1136.5 C 888.488,1136.66 889.821,1139.16 886.5,1144C 880.403,1144.15 879.07,1141.65 882.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 923.5,1136.5 C 927.979,1136.9 929.312,1139.23 927.5,1143.5C 924.208,1145.18 922.208,1144.18 921.5,1140.5C 921.752,1138.93 922.418,1137.59 923.5,1136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 701.5,1146.5 C 706.668,1147.34 707.668,1149.84 704.5,1154C 697.934,1153.81 696.934,1151.31 701.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 741.5,1146.5 C 747.02,1147.04 748.354,1149.54 745.5,1154C 739.403,1154.15 738.07,1151.65 741.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1146.5 C 787.488,1146.66 788.821,1149.16 785.5,1154C 779.403,1154.15 778.07,1151.65 781.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1146.5 C 827.181,1146.88 828.515,1149.21 826.5,1153.5C 823.208,1155.18 821.208,1154.18 820.5,1150.5C 820.752,1148.93 821.418,1147.59 822.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 862.5,1146.5 C 868.488,1146.66 869.821,1149.16 866.5,1154C 860.403,1154.15 859.07,1151.65 862.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 903.5,1146.5 C 908.668,1147.34 909.668,1149.84 906.5,1154C 901.917,1154.93 900.417,1153.1 902,1148.5C 902.717,1147.96 903.217,1147.29 903.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 943.5,1146.5 C 949.02,1147.04 950.354,1149.54 947.5,1154C 941.403,1154.15 940.07,1151.65 943.5,1146.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 721.5,1156.5 C 726.262,1157.09 727.596,1159.59 725.5,1164C 719.202,1164.5 717.868,1162 721.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efe9fd",
    d: "M 761.5,1156.5 C 767.488,1156.66 768.821,1159.16 765.5,1164C 759.403,1164.15 758.07,1161.65 761.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f0fd",
    d: "M 802.5,1156.5 C 807.668,1157.34 808.668,1159.84 805.5,1164C 800.917,1164.93 799.417,1163.1 801,1158.5C 801.717,1157.96 802.217,1157.29 802.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1156.5 C 847.805,1157.24 849.139,1159.74 846.5,1164C 840.403,1164.15 839.07,1161.65 842.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 883.5,1156.5 C 888.668,1157.34 889.668,1159.84 886.5,1164C 879.934,1163.81 878.934,1161.31 883.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1156.5 C 928.262,1157.09 929.596,1159.59 927.5,1164C 924.402,1165.07 922.402,1164.07 921.5,1161C 921.519,1159.17 922.185,1157.67 923.5,1156.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eafd",
    d: "M 701.5,1166.5 C 706.668,1167.34 707.668,1169.84 704.5,1174C 697.951,1173.86 696.951,1171.36 701.5,1166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eafd",
    d: "M 741.5,1166.5 C 746.805,1167.24 748.139,1169.74 745.5,1174C 739.403,1174.15 738.07,1171.65 741.5,1166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 822.5,1166.5 C 827.262,1167.09 828.596,1169.59 826.5,1174C 820.202,1174.5 818.868,1172 822.5,1166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 863.5,1166.5 C 868.328,1167.64 869.328,1170.14 866.5,1174C 862,1174.83 860.167,1173 861,1168.5C 861.995,1167.93 862.828,1167.27 863.5,1166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee8fd",
    d: "M 903.5,1166.5 C 908.262,1167.09 909.596,1169.59 907.5,1174C 900.193,1174.54 898.86,1172.04 903.5,1166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#241f21",
    d: "M 2254.5,1170.5 C 2257.58,1170.26 2260.58,1170.59 2263.5,1171.5C 2263.83,1175.5 2264.17,1179.5 2264.5,1183.5C 2263.92,1224.52 2263.75,1265.52 2264,1306.5C 2303.6,1286.62 2343.44,1267.12 2383.5,1248C 2384.64,1247.25 2385.64,1247.42 2386.5,1248.5C 2387.67,1250.17 2388.83,1251.83 2390,1253.5C 2390.16,1255.39 2389.33,1256.89 2387.5,1258C 2353.28,1284.94 2319.28,1312.1 2285.5,1339.5C 2325.8,1358.98 2366.14,1378.48 2406.5,1398C 2405.41,1400.44 2404.41,1402.94 2403.5,1405.5C 2359.75,1396.98 2316.09,1387.32 2272.5,1376.5C 2275.44,1392.69 2278.6,1409.02 2282,1425.5C 2288.56,1452.82 2295.06,1480.16 2301.5,1507.5C 2298.7,1509.21 2295.7,1510.55 2292.5,1511.5C 2273,1471.17 2253.5,1430.83 2234,1390.5C 2206.3,1425.91 2178.14,1460.91 2149.5,1495.5C 2146.5,1494.33 2143.83,1492.67 2141.5,1490.5C 2161.37,1449.92 2181.37,1409.42 2201.5,1369C 2156.2,1369.02 2110.87,1369.18 2065.5,1369.5C 2065.32,1366.12 2065.32,1362.95 2065.5,1360C 2109.3,1350.28 2152.96,1340.11 2196.5,1329.5C 2168.69,1294.52 2140.69,1259.69 2112.5,1225C 2114.5,1223 2116.5,1221 2118.5,1219C 2119.5,1218.33 2120.5,1218.33 2121.5,1219C 2155.69,1246.69 2190.02,1274.19 2224.5,1301.5C 2234.75,1257.89 2244.75,1214.23 2254.5,1170.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 781.5,1167.5 C 787.555,1166.94 788.888,1169.11 785.5,1174C 779.738,1174.42 778.404,1172.25 781.5,1167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 942.5,1167.5 C 947.006,1166.53 949.172,1168.19 949,1172.5C 945.507,1175.5 943.007,1174.84 941.5,1170.5C 941.685,1169.42 942.018,1168.42 942.5,1167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 720.5,1177.5 C 726.158,1176.68 727.825,1178.85 725.5,1184C 719.741,1185.14 718.074,1182.97 720.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 760.5,1177.5 C 765.006,1176.53 767.172,1178.19 767,1182.5C 763.813,1185.41 761.313,1184.91 759.5,1181C 759.989,1179.86 760.322,1178.69 760.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 801.5,1177.5 C 807.158,1176.68 808.825,1178.85 806.5,1184C 800.741,1185.14 799.074,1182.97 801.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 841.5,1177.5 C 846.006,1176.53 848.172,1178.19 848,1182.5C 841.645,1186.2 839.478,1184.53 841.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1177.5 C 887.894,1176.55 889.561,1178.55 887.5,1183.5C 881.29,1184.97 879.623,1182.97 882.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1177.5 C 928.158,1176.68 929.825,1178.85 927.5,1184C 921.741,1185.14 920.074,1182.97 922.5,1177.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a995d0",
    d: "M 1935.5,1181.5 C 1935.5,1181.83 1935.5,1182.17 1935.5,1182.5C 1912.17,1182.5 1888.83,1182.5 1865.5,1182.5C 1865.83,1284 1865.5,1385.33 1864.5,1486.5C 1864.5,1384.83 1864.5,1283.17 1864.5,1181.5C 1888.17,1181.5 1911.83,1181.5 1935.5,1181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2abf0",
    d: "M 1935.5,1182.5 C 1935.5,1317.5 1935.5,1452.5 1935.5,1587.5C 1796,1587.17 1656.67,1587.5 1517.5,1588.5C 1516.28,1589.03 1515.11,1589.69 1514,1590.5C 1505.38,1603.87 1495.21,1616.03 1483.5,1627C 1478.17,1629.67 1472.83,1632.33 1467.5,1635C 1461.52,1636.09 1455.52,1637.09 1449.5,1638C 1302.83,1638.67 1156.17,1638.67 1009.5,1638C 990.695,1636.68 975.195,1628.85 963,1614.5C 960.217,1610.05 957.05,1605.88 953.5,1602C 963.833,1601.67 974.167,1601.33 984.5,1601C 985.667,1599.83 986.833,1598.67 988,1597.5C 988.014,1570.48 987.181,1543.48 985.5,1516.5C 1268.83,1516.67 1552.17,1516.5 1835.5,1516C 1840.32,1515.17 1844.99,1513.84 1849.5,1512C 1853,1508.5 1856.5,1505 1860,1501.5C 1861.66,1496.53 1863.16,1491.53 1864.5,1486.5C 1865.5,1385.33 1865.83,1284 1865.5,1182.5C 1888.83,1182.5 1912.17,1182.5 1935.5,1182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 700.5,1187.5 C 706.158,1186.68 707.825,1188.85 705.5,1194C 699.244,1194.93 697.577,1192.77 700.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fe",
    d: "M 740.5,1187.5 C 745.006,1186.53 747.172,1188.19 747,1192.5C 740.645,1196.2 738.478,1194.53 740.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f5fe",
    d: "M 781.5,1187.5 C 786.52,1186.91 788.186,1188.91 786.5,1193.5C 780.29,1194.97 778.623,1192.97 781.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 821.5,1187.5 C 827.158,1186.68 828.825,1188.85 826.5,1194C 820.741,1195.14 819.074,1192.97 821.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf9fe",
    d: "M 862.5,1187.5 C 868.016,1187.47 869.349,1189.64 866.5,1194C 860.738,1194.42 859.404,1192.25 862.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 902.5,1187.5 C 908.158,1186.68 909.825,1188.85 907.5,1194C 901.741,1195.14 900.074,1192.97 902.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 942.5,1187.5 C 947.006,1186.53 949.172,1188.19 949,1192.5C 942.645,1196.2 940.478,1194.53 942.5,1187.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 720.5,1197.5 C 726.704,1197.31 728.037,1199.81 724.5,1205C 719.632,1204.71 718.299,1202.21 720.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 801.5,1197.5 C 807.704,1197.31 809.037,1199.81 805.5,1205C 800.632,1204.71 799.299,1202.21 801.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 842.5,1197.5 C 845.571,1196.92 847.571,1198.09 848.5,1201C 845.859,1206.63 843.192,1206.8 840.5,1201.5C 840.752,1199.93 841.418,1198.59 842.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 882.5,1197.5 C 887.486,1197.3 889.152,1199.47 887.5,1204C 881.244,1204.93 879.577,1202.77 882.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 922.5,1197.5 C 928.704,1197.31 930.037,1199.81 926.5,1205C 921.632,1204.71 920.299,1202.21 922.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 761.5,1197.5 C 768.513,1198.54 769.18,1201.21 763.5,1205.5C 759.302,1203.59 758.635,1200.92 761.5,1197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 700.5,1207.5 C 706.488,1207.66 707.821,1210.16 704.5,1215C 698.95,1214.63 697.617,1212.13 700.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 741.5,1207.5 C 744.571,1206.92 746.571,1208.09 747.5,1211C 744.859,1216.63 742.192,1216.8 739.5,1211.5C 739.752,1209.93 740.418,1208.59 741.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeafd",
    d: "M 781.5,1207.5 C 787.488,1207.66 788.821,1210.16 785.5,1215C 779.812,1214.79 778.479,1212.29 781.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 821.5,1207.5 C 827.704,1207.31 829.037,1209.81 825.5,1215C 820.632,1214.71 819.299,1212.21 821.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 862.5,1207.5 C 867.486,1207.3 869.152,1209.47 867.5,1214C 860.561,1215.57 858.894,1213.41 862.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eafd",
    d: "M 902.5,1207.5 C 908.362,1207.66 909.695,1210.16 906.5,1215C 900.95,1214.63 899.617,1212.13 902.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 943.5,1207.5 C 946.571,1206.92 948.571,1208.09 949.5,1211C 946.859,1216.63 944.192,1216.8 941.5,1211.5C 941.752,1209.93 942.418,1208.59 943.5,1207.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 761.5,1217.5 C 767.488,1217.66 768.821,1220.16 765.5,1225C 759.403,1225.15 758.07,1222.65 761.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 882.5,1217.5 C 888.488,1217.66 889.821,1220.16 886.5,1225C 880.812,1224.79 879.479,1222.29 882.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 721.5,1217.5 C 725.605,1217.5 727.105,1219.5 726,1223.5C 722.509,1226.45 720.342,1225.61 719.5,1221C 719.862,1219.57 720.528,1218.4 721.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 801.5,1217.5 C 807.488,1217.66 808.821,1220.16 805.5,1225C 800.632,1224.71 799.299,1222.21 801.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1217.5 C 847.214,1217.2 848.88,1219.2 847.5,1223.5C 844.123,1226.49 841.79,1225.82 840.5,1221.5C 840.752,1219.93 841.418,1218.59 842.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 923.5,1217.5 C 928.068,1217.08 929.568,1219.08 928,1223.5C 924.828,1226.39 922.661,1225.72 921.5,1221.5C 921.752,1219.93 922.418,1218.59 923.5,1217.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfa9ec",
    d: "M 2253.5,1216.5 C 2254.49,1222.98 2254.82,1229.65 2254.5,1236.5C 2254.33,1262.84 2254.5,1289.17 2255,1315.5C 2256.75,1316.63 2258.59,1317.63 2260.5,1318.5C 2288.65,1304.92 2316.65,1291.09 2344.5,1277C 2346.16,1276.21 2347.83,1275.88 2349.5,1276C 2324.5,1295.67 2299.5,1315.33 2274.5,1335C 2272.28,1338.1 2271.95,1341.43 2273.5,1345C 2303.01,1359.26 2332.68,1373.26 2362.5,1387C 2357.46,1386.99 2352.46,1386.33 2347.5,1385C 2319.87,1378.14 2292.2,1371.81 2264.5,1366C 2262.55,1367.44 2261.22,1369.27 2260.5,1371.5C 2268,1403.85 2275.17,1436.19 2282,1468.5C 2268.11,1438.38 2253.94,1408.38 2239.5,1378.5C 2235.46,1376.77 2231.96,1377.44 2229,1380.5C 2209.33,1405.5 2189.67,1430.5 2170,1455.5C 2175.12,1442.91 2181.12,1430.58 2188,1418.5C 2195.86,1400.12 2204.2,1382.12 2213,1364.5C 2211.95,1362.91 2210.79,1361.41 2209.5,1360C 2175.83,1359.64 2142.16,1359.64 2108.5,1360C 2141.44,1352.35 2174.44,1344.85 2207.5,1337.5C 2208.35,1334.84 2208.85,1332.17 2209,1329.5C 2188.65,1303.47 2167.81,1277.8 2146.5,1252.5C 2146.67,1252.17 2146.83,1251.83 2147,1251.5C 2172.77,1273.27 2199.1,1294.27 2226,1314.5C 2229.17,1314.25 2231.33,1312.75 2232.5,1310C 2239.9,1278.91 2246.9,1247.74 2253.5,1216.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c6c0d2",
    d: "M 962.5,1218.5 C 963.461,1220.26 963.795,1222.26 963.5,1224.5C 961.271,1222.9 960.938,1220.9 962.5,1218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#786a8f",
    d: "M 2254.5,1236.5 C 2254.82,1229.65 2254.49,1222.98 2253.5,1216.5C 2253.46,1215.24 2253.96,1214.24 2255,1213.5C 2255.82,1221.34 2255.66,1229.01 2254.5,1236.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 700.5,1227.5 C 706.488,1227.66 707.821,1230.16 704.5,1235C 698.812,1234.79 697.479,1232.29 700.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4effd",
    d: "M 741.5,1227.5 C 746.214,1227.2 747.88,1229.2 746.5,1233.5C 743.123,1236.49 740.79,1235.82 739.5,1231.5C 739.752,1229.93 740.418,1228.59 741.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1227.5 C 787.488,1227.66 788.821,1230.16 785.5,1235C 779.403,1235.15 778.07,1232.65 781.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1227.5 C 826.605,1227.5 828.105,1229.5 827,1233.5C 823.828,1236.39 821.661,1235.72 820.5,1231.5C 820.752,1229.93 821.418,1228.59 822.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 862.5,1227.5 C 868.488,1227.66 869.821,1230.16 866.5,1235C 860.403,1235.15 859.07,1232.65 862.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 903.5,1227.5 C 906.352,1227.35 908.019,1228.69 908.5,1231.5C 907.339,1235.72 905.172,1236.39 902,1233.5C 901.257,1231.13 901.757,1229.13 903.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 943.5,1227.5 C 949.488,1227.66 950.821,1230.16 947.5,1235C 941.403,1235.15 940.07,1232.65 943.5,1227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1237.5 C 724.352,1237.35 726.019,1238.69 726.5,1241.5C 724.167,1246.83 721.833,1246.83 719.5,1241.5C 719.752,1239.93 720.418,1238.59 721.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 761.5,1237.5 C 767.488,1237.66 768.821,1240.16 765.5,1245C 759.403,1245.15 758.07,1242.65 761.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 802.5,1237.5 C 805.352,1237.35 807.019,1238.69 807.5,1241.5C 805.054,1246.71 802.387,1246.71 799.5,1241.5C 800.172,1239.84 801.172,1238.51 802.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee9fd",
    d: "M 842.5,1237.5 C 848.488,1237.66 849.821,1240.16 846.5,1245C 840.403,1245.15 839.07,1242.65 842.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1237.5 C 888.488,1237.66 889.821,1240.16 886.5,1245C 880.403,1245.15 879.07,1242.65 882.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 923.5,1237.5 C 928.181,1237.88 929.515,1240.21 927.5,1244.5C 924.208,1246.18 922.208,1245.18 921.5,1241.5C 921.752,1239.93 922.418,1238.59 923.5,1237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d0c9e1",
    d: "M 963.5,1238.5 C 964.468,1240.61 964.802,1242.94 964.5,1245.5C 961.071,1243.48 960.738,1241.15 963.5,1238.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 701.5,1247.5 C 706.668,1248.34 707.668,1250.84 704.5,1255C 697.934,1254.81 696.934,1252.31 701.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 741.5,1247.5 C 747.02,1248.04 748.354,1250.54 745.5,1255C 739.403,1255.15 738.07,1252.65 741.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 781.5,1247.5 C 787.488,1247.66 788.821,1250.16 785.5,1255C 779.403,1255.15 778.07,1252.65 781.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f4fe",
    d: "M 822.5,1247.5 C 827.181,1247.88 828.515,1250.21 826.5,1254.5C 823.208,1256.18 821.208,1255.18 820.5,1251.5C 820.752,1249.93 821.418,1248.59 822.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 862.5,1247.5 C 868.488,1247.66 869.821,1250.16 866.5,1255C 860.403,1255.15 859.07,1252.65 862.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 943.5,1247.5 C 949.02,1248.04 950.354,1250.54 947.5,1255C 941.403,1255.15 940.07,1252.65 943.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 903.5,1247.5 C 908.668,1248.34 909.668,1250.84 906.5,1255C 901.917,1255.93 900.417,1254.1 902,1249.5C 902.717,1248.96 903.217,1248.29 903.5,1247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 721.5,1257.5 C 726.262,1258.09 727.596,1260.59 725.5,1265C 719.202,1265.5 717.868,1263 721.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 761.5,1257.5 C 765.06,1256.89 767.06,1258.39 767.5,1262C 765.687,1265.91 763.187,1266.41 760,1263.5C 759.252,1261.16 759.752,1259.16 761.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f0fd",
    d: "M 802.5,1257.5 C 807.668,1258.34 808.668,1260.84 805.5,1265C 800.917,1265.93 799.417,1264.1 801,1259.5C 801.717,1258.96 802.217,1258.29 802.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1257.5 C 847.805,1258.24 849.139,1260.74 846.5,1265C 840.403,1265.15 839.07,1262.65 842.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 883.5,1257.5 C 888.668,1258.34 889.668,1260.84 886.5,1265C 879.934,1264.81 878.934,1262.31 883.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1257.5 C 928.262,1258.09 929.596,1260.59 927.5,1265C 924.402,1266.07 922.402,1265.07 921.5,1262C 921.519,1260.17 922.185,1258.67 923.5,1257.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 964.5,1258.5 C 964.5,1260.83 964.5,1263.17 964.5,1265.5C 962.754,1264.75 961.754,1263.42 961.5,1261.5C 961.516,1259.48 962.516,1258.48 964.5,1258.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 701.5,1267.5 C 706.182,1267.87 707.516,1270.21 705.5,1274.5C 698.242,1275.57 696.909,1273.24 701.5,1267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f5fe",
    d: "M 740.5,1268.5 C 745.006,1267.53 747.172,1269.19 747,1273.5C 743.507,1276.5 741.007,1275.84 739.5,1271.5C 739.685,1270.42 740.018,1269.42 740.5,1268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 781.5,1268.5 C 787.555,1267.94 788.888,1270.11 785.5,1275C 779.738,1275.42 778.404,1273.25 781.5,1268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 822.5,1267.5 C 827.262,1268.09 828.596,1270.59 826.5,1275C 820.202,1275.5 818.868,1273 822.5,1267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 863.5,1267.5 C 868.328,1268.64 869.328,1271.14 866.5,1275C 862,1275.83 860.167,1274 861,1269.5C 861.995,1268.93 862.828,1268.27 863.5,1267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fe",
    d: "M 903.5,1267.5 C 908.262,1268.09 909.596,1270.59 907.5,1275C 901.202,1275.5 899.868,1273 903.5,1267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 942.5,1268.5 C 947.006,1267.53 949.172,1269.19 949,1273.5C 945.507,1276.5 943.007,1275.84 941.5,1271.5C 941.685,1270.42 942.018,1269.42 942.5,1268.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 720.5,1278.5 C 726.158,1277.68 727.825,1279.85 725.5,1285C 719.741,1286.14 718.074,1283.97 720.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 760.5,1278.5 C 765.006,1277.53 767.172,1279.19 767,1283.5C 763.813,1286.41 761.313,1285.91 759.5,1282C 759.989,1280.86 760.322,1279.69 760.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 801.5,1278.5 C 807.158,1277.68 808.825,1279.85 806.5,1285C 800.741,1286.14 799.074,1283.97 801.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 841.5,1278.5 C 846.006,1277.53 848.172,1279.19 848,1283.5C 841.645,1287.2 839.478,1285.53 841.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1278.5 C 887.894,1277.55 889.561,1279.55 887.5,1284.5C 881.29,1285.97 879.623,1283.97 882.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1278.5 C 928.158,1277.68 929.825,1279.85 927.5,1285C 921.741,1286.14 920.074,1283.97 922.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf9fe",
    d: "M 965.5,1278.5 C 965.5,1280.83 965.5,1283.17 965.5,1285.5C 960.167,1283.17 960.167,1280.83 965.5,1278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 700.5,1288.5 C 706.158,1287.68 707.825,1289.85 705.5,1295C 699.244,1295.93 697.577,1293.77 700.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 740.5,1288.5 C 745.006,1287.53 747.172,1289.19 747,1293.5C 740.645,1297.2 738.478,1295.53 740.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 781.5,1288.5 C 786.52,1287.91 788.186,1289.91 786.5,1294.5C 780.29,1295.97 778.623,1293.97 781.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 862.5,1288.5 C 868.016,1288.47 869.349,1290.64 866.5,1295C 860.738,1295.42 859.404,1293.25 862.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 902.5,1288.5 C 908.158,1287.68 909.825,1289.85 907.5,1295C 901.244,1295.93 899.577,1293.77 902.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 821.5,1288.5 C 827.158,1287.68 828.825,1289.85 826.5,1295C 820.741,1296.14 819.074,1293.97 821.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 942.5,1288.5 C 947.006,1287.53 949.172,1289.19 949,1293.5C 942.681,1297.2 940.514,1295.54 942.5,1288.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4f378c",
    d: "M 965.5,1285.5 C 966.485,1289.63 966.818,1293.97 966.5,1298.5C 965.833,1298.5 965.167,1298.5 964.5,1298.5C 965.436,1294.26 965.769,1289.93 965.5,1285.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 720.5,1298.5 C 726.704,1298.31 728.037,1300.81 724.5,1306C 719.632,1305.71 718.299,1303.21 720.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 761.5,1298.5 C 764.571,1297.92 766.571,1299.09 767.5,1302C 764.833,1308 762.167,1308 759.5,1302C 759.978,1300.7 760.645,1299.53 761.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 801.5,1298.5 C 807.704,1298.31 809.037,1300.81 805.5,1306C 800.632,1305.71 799.299,1303.21 801.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 842.5,1298.5 C 845.571,1297.92 847.571,1299.09 848.5,1302C 845.859,1307.63 843.192,1307.8 840.5,1302.5C 840.752,1300.93 841.418,1299.59 842.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 882.5,1298.5 C 887.486,1298.3 889.152,1300.47 887.5,1305C 881.244,1305.93 879.577,1303.77 882.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 922.5,1298.5 C 928.704,1298.31 930.037,1300.81 926.5,1306C 921.632,1305.71 920.299,1303.21 922.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0edf8",
    d: "M 964.5,1298.5 C 965.167,1298.5 965.833,1298.5 966.5,1298.5C 966.5,1301.17 966.5,1303.83 966.5,1306.5C 961.035,1304.8 960.368,1302.13 964.5,1298.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1308.5 C 706.488,1308.66 707.821,1311.16 704.5,1316C 698.95,1315.63 697.617,1313.13 700.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 741.5,1308.5 C 744.571,1307.92 746.571,1309.09 747.5,1312C 744.859,1317.63 742.192,1317.8 739.5,1312.5C 739.752,1310.93 740.418,1309.59 741.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 781.5,1308.5 C 787.488,1308.66 788.821,1311.16 785.5,1316C 779.812,1315.79 778.479,1313.29 781.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 821.5,1308.5 C 827.704,1308.31 829.037,1310.81 825.5,1316C 820.632,1315.71 819.299,1313.21 821.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 862.5,1308.5 C 868.488,1308.66 869.821,1311.16 866.5,1316C 860.403,1316.15 859.07,1313.65 862.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 902.5,1308.5 C 908.362,1308.66 909.695,1311.16 906.5,1316C 901.632,1315.71 900.299,1313.21 902.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 943.5,1308.5 C 946.571,1307.92 948.571,1309.09 949.5,1312C 946.859,1317.63 944.192,1317.8 941.5,1312.5C 941.752,1310.93 942.418,1309.59 943.5,1308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 761.5,1318.5 C 767.488,1318.66 768.821,1321.16 765.5,1326C 759.403,1326.15 758.07,1323.65 761.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 882.5,1318.5 C 888.488,1318.66 889.821,1321.16 886.5,1326C 880.812,1325.79 879.479,1323.29 882.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6e2ef",
    d: "M 966.5,1318.5 C 967.473,1320.95 967.806,1323.61 967.5,1326.5C 966.127,1326.66 964.793,1326.49 963.5,1326C 960.332,1321.84 961.332,1319.34 966.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 721.5,1318.5 C 725.605,1318.5 727.105,1320.5 726,1324.5C 722.509,1327.45 720.342,1326.61 719.5,1322C 719.862,1320.57 720.528,1319.4 721.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 801.5,1318.5 C 807.488,1318.66 808.821,1321.16 805.5,1326C 800.632,1325.71 799.299,1323.21 801.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1318.5 C 847.214,1318.2 848.88,1320.2 847.5,1324.5C 844.123,1327.49 841.79,1326.82 840.5,1322.5C 840.752,1320.93 841.418,1319.59 842.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 923.5,1318.5 C 928.068,1318.08 929.568,1320.08 928,1324.5C 924.828,1327.39 922.661,1326.72 921.5,1322.5C 921.752,1320.93 922.418,1319.59 923.5,1318.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1328.5 C 706.488,1328.66 707.821,1331.16 704.5,1336C 698.812,1335.79 697.479,1333.29 700.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 741.5,1328.5 C 746.378,1328.53 747.711,1330.87 745.5,1335.5C 742.208,1337.18 740.208,1336.18 739.5,1332.5C 739.752,1330.93 740.418,1329.59 741.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 781.5,1328.5 C 787.488,1328.66 788.821,1331.16 785.5,1336C 779.403,1336.15 778.07,1333.65 781.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1328.5 C 826.605,1328.5 828.105,1330.5 827,1334.5C 823.828,1337.39 821.661,1336.72 820.5,1332.5C 820.752,1330.93 821.418,1329.59 822.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 862.5,1328.5 C 868.488,1328.66 869.821,1331.16 866.5,1336C 860.403,1336.15 859.07,1333.65 862.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 903.5,1328.5 C 906.352,1328.35 908.019,1329.69 908.5,1332.5C 907.339,1336.72 905.172,1337.39 902,1334.5C 901.257,1332.13 901.757,1330.13 903.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 943.5,1328.5 C 949.488,1328.66 950.821,1331.16 947.5,1336C 941.403,1336.15 940.07,1333.65 943.5,1328.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1338.5 C 724.352,1338.35 726.019,1339.69 726.5,1342.5C 724.167,1347.83 721.833,1347.83 719.5,1342.5C 719.752,1340.93 720.418,1339.59 721.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 761.5,1338.5 C 767.488,1338.66 768.821,1341.16 765.5,1346C 759.403,1346.15 758.07,1343.65 761.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 802.5,1338.5 C 807.668,1339.34 808.668,1341.84 805.5,1346C 802.186,1347.16 800.186,1346 799.5,1342.5C 800.172,1340.84 801.172,1339.51 802.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee9fd",
    d: "M 842.5,1338.5 C 848.488,1338.66 849.821,1341.16 846.5,1346C 840.403,1346.15 839.07,1343.65 842.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1338.5 C 888.488,1338.66 889.821,1341.16 886.5,1346C 880.403,1346.15 879.07,1343.65 882.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 923.5,1338.5 C 928.181,1338.88 929.515,1341.21 927.5,1345.5C 924.208,1347.18 922.208,1346.18 921.5,1342.5C 921.752,1340.93 922.418,1339.59 923.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 967.5,1338.5 C 967.5,1340.83 967.5,1343.17 967.5,1345.5C 966.399,1346.6 965.066,1346.76 963.5,1346C 960.179,1341.16 961.512,1338.66 967.5,1338.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 701.5,1348.5 C 706.668,1349.34 707.668,1351.84 704.5,1356C 697.934,1355.81 696.934,1353.31 701.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 741.5,1348.5 C 747.02,1349.04 748.354,1351.54 745.5,1356C 739.403,1356.15 738.07,1353.65 741.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1348.5 C 787.488,1348.66 788.821,1351.16 785.5,1356C 779.403,1356.15 778.07,1353.65 781.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1348.5 C 827.181,1348.88 828.515,1351.21 826.5,1355.5C 823.208,1357.18 821.208,1356.18 820.5,1352.5C 820.752,1350.93 821.418,1349.59 822.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 862.5,1348.5 C 868.488,1348.66 869.821,1351.16 866.5,1356C 860.403,1356.15 859.07,1353.65 862.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 903.5,1348.5 C 908.668,1349.34 909.668,1351.84 906.5,1356C 901.917,1356.93 900.417,1355.1 902,1350.5C 902.717,1349.96 903.217,1349.29 903.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 943.5,1348.5 C 949.02,1349.04 950.354,1351.54 947.5,1356C 941.403,1356.15 940.07,1353.65 943.5,1348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 721.5,1358.5 C 726.262,1359.09 727.596,1361.59 725.5,1366C 719.202,1366.5 717.868,1364 721.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efe9fd",
    d: "M 761.5,1358.5 C 767.488,1358.66 768.821,1361.16 765.5,1366C 759.403,1366.15 758.07,1363.65 761.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 802.5,1358.5 C 807.668,1359.34 808.668,1361.84 805.5,1366C 800.917,1366.93 799.417,1365.1 801,1360.5C 801.717,1359.96 802.217,1359.29 802.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1358.5 C 847.805,1359.24 849.139,1361.74 846.5,1366C 840.403,1366.15 839.07,1363.65 842.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 883.5,1358.5 C 888.668,1359.34 889.668,1361.84 886.5,1366C 879.934,1365.81 878.934,1363.31 883.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1358.5 C 928.262,1359.09 929.596,1361.59 927.5,1366C 924.402,1367.07 922.402,1366.07 921.5,1363C 921.519,1361.17 922.185,1359.67 923.5,1358.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 968.5,1359.5 C 968.5,1361.17 968.5,1362.83 968.5,1364.5C 968.5,1364.83 968.5,1365.17 968.5,1365.5C 964.92,1367.36 962.586,1366.36 961.5,1362.5C 962.586,1358.64 964.92,1357.64 968.5,1359.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 740.5,1369.5 C 745.006,1368.53 747.172,1370.19 747,1374.5C 743.507,1377.5 741.007,1376.84 739.5,1372.5C 739.685,1371.42 740.018,1370.42 740.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 781.5,1369.5 C 787.555,1368.94 788.888,1371.11 785.5,1376C 779.738,1376.42 778.404,1374.25 781.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 863.5,1368.5 C 868.328,1369.64 869.328,1372.14 866.5,1376C 862,1376.83 860.167,1375 861,1370.5C 861.995,1369.93 862.828,1369.27 863.5,1368.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 700.5,1369.5 C 705.894,1368.55 707.561,1370.55 705.5,1375.5C 699.29,1376.97 697.623,1374.97 700.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 821.5,1369.5 C 827.158,1368.68 828.825,1370.85 826.5,1376C 820.741,1377.14 819.074,1374.97 821.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 902.5,1369.5 C 908.158,1368.68 909.825,1370.85 907.5,1376C 901.244,1376.93 899.577,1374.77 902.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 942.5,1369.5 C 947.006,1368.53 949.172,1370.19 949,1374.5C 945.507,1377.5 943.007,1376.84 941.5,1372.5C 941.685,1371.42 942.018,1370.42 942.5,1369.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#553c97",
    d: "M 968.5,1364.5 C 969.489,1369.98 969.822,1375.64 969.5,1381.5C 968.5,1381.17 967.833,1380.5 967.5,1379.5C 968.486,1375.03 968.819,1370.36 968.5,1365.5C 968.5,1365.17 968.5,1364.83 968.5,1364.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 720.5,1379.5 C 726.158,1378.68 727.825,1380.85 725.5,1386C 719.741,1387.14 718.074,1384.97 720.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 760.5,1379.5 C 765.006,1378.53 767.172,1380.19 767,1384.5C 763.813,1387.41 761.313,1386.91 759.5,1383C 759.989,1381.86 760.322,1380.69 760.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 801.5,1379.5 C 807.158,1378.68 808.825,1380.85 806.5,1386C 800.741,1387.14 799.074,1384.97 801.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 841.5,1379.5 C 846.006,1378.53 848.172,1380.19 848,1384.5C 841.645,1388.2 839.478,1386.53 841.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1379.5 C 887.894,1378.55 889.561,1380.55 887.5,1385.5C 881.29,1386.97 879.623,1384.97 882.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1379.5 C 928.158,1378.68 929.825,1380.85 927.5,1386C 921.741,1387.14 920.074,1384.97 922.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f8fd",
    d: "M 967.5,1379.5 C 967.833,1380.5 968.5,1381.17 969.5,1381.5C 969.5,1382.5 969.5,1383.5 969.5,1384.5C 966.994,1387.09 964.494,1387.09 962,1384.5C 961.658,1380.68 963.491,1379.01 967.5,1379.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fe",
    d: "M 700.5,1389.5 C 706.158,1388.68 707.825,1390.85 705.5,1396C 699.244,1396.93 697.577,1394.77 700.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fe",
    d: "M 740.5,1389.5 C 745.006,1388.53 747.172,1390.19 747,1394.5C 740.645,1398.2 738.478,1396.53 740.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 781.5,1389.5 C 786.214,1389.2 787.88,1391.2 786.5,1395.5C 780.29,1396.97 778.623,1394.97 781.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 821.5,1389.5 C 827.158,1388.68 828.825,1390.85 826.5,1396C 820.741,1397.14 819.074,1394.97 821.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fbf9fe",
    d: "M 862.5,1389.5 C 868.016,1389.47 869.349,1391.64 866.5,1396C 860.738,1396.42 859.404,1394.25 862.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 902.5,1389.5 C 908.158,1388.68 909.825,1390.85 907.5,1396C 901.741,1397.14 900.074,1394.97 902.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 942.5,1389.5 C 947.006,1388.53 949.172,1390.19 949,1394.5C 942.681,1398.2 940.514,1396.54 942.5,1389.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 720.5,1399.5 C 726.704,1399.31 728.037,1401.81 724.5,1407C 719.632,1406.71 718.299,1404.21 720.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 801.5,1399.5 C 807.704,1399.31 809.037,1401.81 805.5,1407C 800.632,1406.71 799.299,1404.21 801.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 842.5,1399.5 C 845.571,1398.92 847.571,1400.09 848.5,1403C 845.859,1408.63 843.192,1408.8 840.5,1403.5C 840.752,1401.93 841.418,1400.59 842.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fd",
    d: "M 882.5,1399.5 C 887.486,1399.3 889.152,1401.47 887.5,1406C 881.244,1406.93 879.577,1404.77 882.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ebfd",
    d: "M 922.5,1399.5 C 928.704,1399.31 930.037,1401.81 926.5,1407C 921.632,1406.71 920.299,1404.21 922.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 963.5,1399.5 C 966.571,1398.92 968.571,1400.09 969.5,1403C 966.833,1409 964.167,1409 961.5,1403C 961.978,1401.7 962.645,1400.53 963.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 761.5,1399.5 C 764.571,1398.92 766.571,1400.09 767.5,1403C 766.086,1407.47 763.586,1408.3 760,1405.5C 759.252,1403.16 759.752,1401.16 761.5,1399.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 700.5,1409.5 C 706.488,1409.66 707.821,1412.16 704.5,1417C 698.95,1416.63 697.617,1414.13 700.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 741.5,1409.5 C 744.571,1408.92 746.571,1410.09 747.5,1413C 744.859,1418.63 742.192,1418.8 739.5,1413.5C 739.752,1411.93 740.418,1410.59 741.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeafd",
    d: "M 781.5,1409.5 C 787.488,1409.66 788.821,1412.16 785.5,1417C 779.812,1416.79 778.479,1414.29 781.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 821.5,1409.5 C 827.704,1409.31 829.037,1411.81 825.5,1417C 820.632,1416.71 819.299,1414.21 821.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eee8fd",
    d: "M 862.5,1409.5 C 868.488,1409.66 869.821,1412.16 866.5,1417C 860.403,1417.15 859.07,1414.65 862.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0eafd",
    d: "M 902.5,1409.5 C 908.362,1409.66 909.695,1412.16 906.5,1417C 900.95,1416.63 899.617,1414.13 902.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 943.5,1409.5 C 946.571,1408.92 948.571,1410.09 949.5,1413C 946.859,1418.63 944.192,1418.8 941.5,1413.5C 941.752,1411.93 942.418,1410.59 943.5,1409.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 761.5,1419.5 C 767.488,1419.66 768.821,1422.16 765.5,1427C 759.403,1427.15 758.07,1424.65 761.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 963.5,1419.5 C 969.488,1419.66 970.821,1422.16 967.5,1427C 961.403,1427.15 960.07,1424.65 963.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 721.5,1419.5 C 725.605,1419.5 727.105,1421.5 726,1425.5C 722.509,1428.45 720.342,1427.61 719.5,1423C 719.862,1421.57 720.528,1420.4 721.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 801.5,1419.5 C 807.488,1419.66 808.821,1422.16 805.5,1427C 800.632,1426.71 799.299,1424.21 801.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1419.5 C 847.214,1419.2 848.88,1421.2 847.5,1425.5C 844.123,1428.49 841.79,1427.82 840.5,1423.5C 840.752,1421.93 841.418,1420.59 842.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 882.5,1419.5 C 888.488,1419.66 889.821,1422.16 886.5,1427C 880.812,1426.79 879.479,1424.29 882.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 923.5,1419.5 C 927.605,1419.5 929.105,1421.5 928,1425.5C 924.828,1428.39 922.661,1427.72 921.5,1423.5C 921.752,1421.93 922.418,1420.59 923.5,1419.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 700.5,1429.5 C 706.488,1429.66 707.821,1432.16 704.5,1437C 698.812,1436.79 697.479,1434.29 700.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4effd",
    d: "M 741.5,1429.5 C 746.214,1429.2 747.88,1431.2 746.5,1435.5C 743.123,1438.49 740.79,1437.82 739.5,1433.5C 739.752,1431.93 740.418,1430.59 741.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1429.5 C 787.488,1429.66 788.821,1432.16 785.5,1437C 779.403,1437.15 778.07,1434.65 781.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1429.5 C 826.605,1429.5 828.105,1431.5 827,1435.5C 823.828,1438.39 821.661,1437.72 820.5,1433.5C 820.752,1431.93 821.418,1430.59 822.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 862.5,1429.5 C 868.488,1429.66 869.821,1432.16 866.5,1437C 860.403,1437.15 859.07,1434.65 862.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 903.5,1429.5 C 906.352,1429.35 908.019,1430.69 908.5,1433.5C 906.118,1438.81 903.785,1438.81 901.5,1433.5C 901.803,1431.89 902.47,1430.55 903.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 943.5,1429.5 C 949.488,1429.66 950.821,1432.16 947.5,1437C 941.403,1437.15 940.07,1434.65 943.5,1429.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1439.5 C 724.352,1439.35 726.019,1440.69 726.5,1443.5C 724.167,1448.83 721.833,1448.83 719.5,1443.5C 719.752,1441.93 720.418,1440.59 721.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 761.5,1439.5 C 767.488,1439.66 768.821,1442.16 765.5,1447C 759.403,1447.15 758.07,1444.65 761.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 802.5,1439.5 C 807.668,1440.34 808.668,1442.84 805.5,1447C 802.186,1448.16 800.186,1447 799.5,1443.5C 800.172,1441.84 801.172,1440.51 802.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efe9fd",
    d: "M 842.5,1439.5 C 846.06,1438.89 848.06,1440.39 848.5,1444C 846.687,1447.91 844.187,1448.41 841,1445.5C 840.252,1443.16 840.752,1441.16 842.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1439.5 C 888.488,1439.66 889.821,1442.16 886.5,1447C 880.403,1447.15 879.07,1444.65 882.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 923.5,1439.5 C 928.262,1440.09 929.596,1442.59 927.5,1447C 921.403,1447.15 920.07,1444.65 923.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 963.5,1439.5 C 969.488,1439.66 970.821,1442.16 967.5,1447C 961.403,1447.15 960.07,1444.65 963.5,1439.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 701.5,1449.5 C 706.668,1450.34 707.668,1452.84 704.5,1457C 697.951,1456.86 696.951,1454.36 701.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 741.5,1449.5 C 747.02,1450.04 748.354,1452.54 745.5,1457C 739.403,1457.15 738.07,1454.65 741.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 781.5,1449.5 C 787.488,1449.66 788.821,1452.16 785.5,1457C 779.403,1457.15 778.07,1454.65 781.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f4fe",
    d: "M 822.5,1449.5 C 827.181,1449.88 828.515,1452.21 826.5,1456.5C 823.208,1458.18 821.208,1457.18 820.5,1453.5C 820.752,1451.93 821.418,1450.59 822.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 862.5,1449.5 C 868.488,1449.66 869.821,1452.16 866.5,1457C 860.403,1457.15 859.07,1454.65 862.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 943.5,1449.5 C 949.02,1450.04 950.354,1452.54 947.5,1457C 941.403,1457.15 940.07,1454.65 943.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 903.5,1449.5 C 908.668,1450.34 909.668,1452.84 906.5,1457C 901.917,1457.93 900.417,1456.1 902,1451.5C 902.717,1450.96 903.217,1450.29 903.5,1449.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 721.5,1459.5 C 726.262,1460.09 727.596,1462.59 725.5,1467C 719.202,1467.5 717.868,1465 721.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efe9fd",
    d: "M 761.5,1459.5 C 767.488,1459.66 768.821,1462.16 765.5,1467C 759.403,1467.15 758.07,1464.65 761.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 802.5,1459.5 C 807.668,1460.34 808.668,1462.84 805.5,1467C 800.917,1467.93 799.417,1466.1 801,1461.5C 801.717,1460.96 802.217,1460.29 802.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1459.5 C 847.805,1460.24 849.139,1462.74 846.5,1467C 840.403,1467.15 839.07,1464.65 842.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 883.5,1459.5 C 888.668,1460.34 889.668,1462.84 886.5,1467C 879.934,1466.81 878.934,1464.31 883.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1459.5 C 928.262,1460.09 929.596,1462.59 927.5,1467C 924.402,1468.07 922.402,1467.07 921.5,1464C 921.519,1462.17 922.185,1460.67 923.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 963.5,1459.5 C 969.488,1459.66 970.821,1462.16 967.5,1467C 961.403,1467.15 960.07,1464.65 963.5,1459.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 700.5,1470.5 C 705.894,1469.55 707.561,1471.55 705.5,1476.5C 699.29,1477.97 697.623,1475.97 700.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f5fe",
    d: "M 740.5,1470.5 C 745.006,1469.53 747.172,1471.19 747,1475.5C 743.507,1478.5 741.007,1477.84 739.5,1473.5C 739.685,1472.42 740.018,1471.42 740.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 781.5,1470.5 C 787.555,1469.94 788.888,1472.11 785.5,1477C 779.738,1477.42 778.404,1475.25 781.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f6fe",
    d: "M 821.5,1470.5 C 827.158,1469.68 828.825,1471.85 826.5,1477C 820.741,1478.14 819.074,1475.97 821.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 863.5,1469.5 C 868.328,1470.64 869.328,1473.14 866.5,1477C 862,1477.83 860.167,1476 861,1471.5C 861.995,1470.93 862.828,1470.27 863.5,1469.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 902.5,1470.5 C 908.158,1469.68 909.825,1471.85 907.5,1477C 901.741,1478.14 900.074,1475.97 902.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 942.5,1470.5 C 947.006,1469.53 949.172,1471.19 949,1475.5C 945.507,1478.5 943.007,1477.84 941.5,1473.5C 941.685,1472.42 942.018,1471.42 942.5,1470.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 720.5,1480.5 C 726.158,1479.68 727.825,1481.85 725.5,1487C 719.741,1488.14 718.074,1485.97 720.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 760.5,1480.5 C 765.006,1479.53 767.172,1481.19 767,1485.5C 763.813,1488.41 761.313,1487.91 759.5,1484C 759.989,1482.86 760.322,1481.69 760.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 801.5,1480.5 C 807.158,1479.68 808.825,1481.85 806.5,1487C 800.741,1488.14 799.074,1485.97 801.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 841.5,1480.5 C 846.006,1479.53 848.172,1481.19 848,1485.5C 841.645,1489.2 839.478,1487.53 841.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1480.5 C 887.894,1479.55 889.561,1481.55 887.5,1486.5C 881.29,1487.97 879.623,1485.97 882.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1480.5 C 928.158,1479.68 929.825,1481.85 927.5,1487C 921.741,1488.14 920.074,1485.97 922.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf9fe",
    d: "M 963.5,1480.5 C 969.016,1480.47 970.349,1482.64 967.5,1487C 961.738,1487.42 960.404,1485.25 963.5,1480.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 700.5,1490.5 C 706.158,1489.68 707.825,1491.85 705.5,1497C 699.244,1497.93 697.577,1495.77 700.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 740.5,1490.5 C 745.006,1489.53 747.172,1491.19 747,1495.5C 740.645,1499.2 738.478,1497.53 740.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 862.5,1490.5 C 868.016,1490.47 869.349,1492.64 866.5,1497C 860.738,1497.42 859.404,1495.25 862.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 902.5,1490.5 C 908.158,1489.68 909.825,1491.85 907.5,1497C 901.244,1497.93 899.577,1495.77 902.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 781.5,1490.5 C 786.214,1490.2 787.88,1492.2 786.5,1496.5C 780.29,1497.97 778.623,1495.97 781.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 821.5,1490.5 C 827.158,1489.68 828.825,1491.85 826.5,1497C 820.741,1498.14 819.074,1495.97 821.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 942.5,1490.5 C 947.006,1489.53 949.172,1491.19 949,1495.5C 942.681,1499.2 940.514,1497.54 942.5,1490.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 720.5,1500.5 C 726.704,1500.31 728.037,1502.81 724.5,1508C 719.632,1507.71 718.299,1505.21 720.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 801.5,1500.5 C 807.704,1500.31 809.037,1502.81 805.5,1508C 800.632,1507.71 799.299,1505.21 801.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 842.5,1500.5 C 845.571,1499.92 847.571,1501.09 848.5,1504C 845.859,1509.63 843.192,1509.8 840.5,1504.5C 840.752,1502.93 841.418,1501.59 842.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 882.5,1500.5 C 888.488,1500.66 889.821,1503.16 886.5,1508C 880.95,1507.63 879.617,1505.13 882.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ebfd",
    d: "M 922.5,1500.5 C 928.704,1500.31 930.037,1502.81 926.5,1508C 921.632,1507.71 920.299,1505.21 922.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 963.5,1500.5 C 966.571,1499.92 968.571,1501.09 969.5,1504C 966.833,1510 964.167,1510 961.5,1504C 961.978,1502.7 962.645,1501.53 963.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 761.5,1500.5 C 764.571,1499.92 766.571,1501.09 767.5,1504C 766.086,1508.47 763.586,1509.3 760,1506.5C 759.252,1504.16 759.752,1502.16 761.5,1500.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1510.5 C 706.488,1510.66 707.821,1513.16 704.5,1518C 698.95,1517.63 697.617,1515.13 700.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 741.5,1510.5 C 744.571,1509.92 746.571,1511.09 747.5,1514C 744.859,1519.63 742.192,1519.8 739.5,1514.5C 739.752,1512.93 740.418,1511.59 741.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 781.5,1510.5 C 787.488,1510.66 788.821,1513.16 785.5,1518C 779.812,1517.79 778.479,1515.29 781.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f2fe",
    d: "M 821.5,1510.5 C 827.704,1510.31 829.037,1512.81 825.5,1518C 820.632,1517.71 819.299,1515.21 821.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 862.5,1510.5 C 868.488,1510.66 869.821,1513.16 866.5,1518C 860.403,1518.15 859.07,1515.65 862.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 902.5,1510.5 C 908.362,1510.66 909.695,1513.16 906.5,1518C 901.632,1517.71 900.299,1515.21 902.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 943.5,1510.5 C 948.214,1510.2 949.88,1512.2 948.5,1516.5C 945.123,1519.49 942.79,1518.82 941.5,1514.5C 941.752,1512.93 942.418,1511.59 943.5,1510.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 761.5,1520.5 C 767.488,1520.66 768.821,1523.16 765.5,1528C 759.403,1528.15 758.07,1525.65 761.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 963.5,1520.5 C 969.488,1520.66 970.821,1523.16 967.5,1528C 961.403,1528.15 960.07,1525.65 963.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 721.5,1520.5 C 725.605,1520.5 727.105,1522.5 726,1526.5C 722.509,1529.45 720.342,1528.61 719.5,1524C 719.862,1522.57 720.528,1521.4 721.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 801.5,1520.5 C 807.488,1520.66 808.821,1523.16 805.5,1528C 800.632,1527.71 799.299,1525.21 801.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1520.5 C 847.214,1520.2 848.88,1522.2 847.5,1526.5C 844.123,1529.49 841.79,1528.82 840.5,1524.5C 840.752,1522.93 841.418,1521.59 842.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 882.5,1520.5 C 888.488,1520.66 889.821,1523.16 886.5,1528C 880.812,1527.79 879.479,1525.29 882.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f1fd",
    d: "M 923.5,1520.5 C 927.605,1520.5 929.105,1522.5 928,1526.5C 924.828,1529.39 922.661,1528.72 921.5,1524.5C 921.752,1522.93 922.418,1521.59 923.5,1520.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 700.5,1530.5 C 706.488,1530.66 707.821,1533.16 704.5,1538C 698.812,1537.79 697.479,1535.29 700.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 741.5,1530.5 C 746.378,1530.53 747.711,1532.87 745.5,1537.5C 742.208,1539.18 740.208,1538.18 739.5,1534.5C 739.752,1532.93 740.418,1531.59 741.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 781.5,1530.5 C 787.488,1530.66 788.821,1533.16 785.5,1538C 779.403,1538.15 778.07,1535.65 781.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1530.5 C 826.605,1530.5 828.105,1532.5 827,1536.5C 823.828,1539.39 821.661,1538.72 820.5,1534.5C 820.752,1532.93 821.418,1531.59 822.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 862.5,1530.5 C 868.488,1530.66 869.821,1533.16 866.5,1538C 860.403,1538.15 859.07,1535.65 862.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 903.5,1530.5 C 906.352,1530.35 908.019,1531.69 908.5,1534.5C 907.339,1538.72 905.172,1539.39 902,1536.5C 901.257,1534.13 901.757,1532.13 903.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 943.5,1530.5 C 949.488,1530.66 950.821,1533.16 947.5,1538C 941.403,1538.15 940.07,1535.65 943.5,1530.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3fe",
    d: "M 721.5,1540.5 C 724.352,1540.35 726.019,1541.69 726.5,1544.5C 724.167,1549.83 721.833,1549.83 719.5,1544.5C 719.752,1542.93 720.418,1541.59 721.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 761.5,1540.5 C 767.488,1540.66 768.821,1543.16 765.5,1548C 759.403,1548.15 758.07,1545.65 761.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 802.5,1540.5 C 807.668,1541.34 808.668,1543.84 805.5,1548C 802.186,1549.16 800.186,1548 799.5,1544.5C 800.172,1542.84 801.172,1541.51 802.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 842.5,1540.5 C 846.06,1539.89 848.06,1541.39 848.5,1545C 846.687,1548.91 844.187,1549.41 841,1546.5C 840.252,1544.16 840.752,1542.16 842.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 882.5,1540.5 C 888.488,1540.66 889.821,1543.16 886.5,1548C 880.403,1548.15 879.07,1545.65 882.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 923.5,1540.5 C 928.262,1541.09 929.596,1543.59 927.5,1548C 921.403,1548.15 920.07,1545.65 923.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 963.5,1540.5 C 969.488,1540.66 970.821,1543.16 967.5,1548C 961.403,1548.15 960.07,1545.65 963.5,1540.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 701.5,1550.5 C 706.668,1551.34 707.668,1553.84 704.5,1558C 697.951,1557.86 696.951,1555.36 701.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 741.5,1550.5 C 747.02,1551.04 748.354,1553.54 745.5,1558C 739.403,1558.15 738.07,1555.65 741.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 781.5,1550.5 C 787.488,1550.66 788.821,1553.16 785.5,1558C 779.403,1558.15 778.07,1555.65 781.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 822.5,1550.5 C 827.181,1550.88 828.515,1553.21 826.5,1557.5C 823.208,1559.18 821.208,1558.18 820.5,1554.5C 820.752,1552.93 821.418,1551.59 822.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 862.5,1550.5 C 868.488,1550.66 869.821,1553.16 866.5,1558C 860.403,1558.15 859.07,1555.65 862.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f6fe",
    d: "M 903.5,1550.5 C 908.668,1551.34 909.668,1553.84 906.5,1558C 901.917,1558.93 900.417,1557.1 902,1552.5C 902.717,1551.96 903.217,1551.29 903.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 943.5,1550.5 C 949.02,1551.04 950.354,1553.54 947.5,1558C 941.403,1558.15 940.07,1555.65 943.5,1550.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 721.5,1560.5 C 726.262,1561.09 727.596,1563.59 725.5,1568C 719.202,1568.5 717.868,1566 721.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3eefd",
    d: "M 761.5,1560.5 C 765.06,1559.89 767.06,1561.39 767.5,1565C 765.687,1568.91 763.187,1569.41 760,1566.5C 759.252,1564.16 759.752,1562.16 761.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 802.5,1560.5 C 807.668,1561.34 808.668,1563.84 805.5,1568C 800.917,1568.93 799.417,1567.1 801,1562.5C 801.717,1561.96 802.217,1561.29 802.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 842.5,1560.5 C 847.805,1561.24 849.139,1563.74 846.5,1568C 840.403,1568.15 839.07,1565.65 842.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1edfd",
    d: "M 883.5,1560.5 C 888.668,1561.34 889.668,1563.84 886.5,1568C 879.934,1567.81 878.934,1565.31 883.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 923.5,1560.5 C 928.262,1561.09 929.596,1563.59 927.5,1568C 924.402,1569.07 922.402,1568.07 921.5,1565C 921.519,1563.17 922.185,1561.67 923.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ecfd",
    d: "M 963.5,1560.5 C 969.488,1560.66 970.821,1563.16 967.5,1568C 961.403,1568.15 960.07,1565.65 963.5,1560.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#242021",
    d: "M 126.5,1569.5 C 151.738,1570.57 162.571,1583.57 159,1608.5C 151.721,1625.72 138.888,1632.22 120.5,1628C 101.424,1618.11 96.2576,1603.28 105,1583.5C 110.24,1575.74 117.407,1571.07 126.5,1569.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 781.5,1571.5 C 787.555,1570.94 788.888,1573.11 785.5,1578C 779.738,1578.42 778.404,1576.25 781.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1ebfd",
    d: "M 863.5,1570.5 C 868.328,1571.64 869.328,1574.14 866.5,1578C 859.934,1577.81 858.934,1575.31 863.5,1570.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edfd",
    d: "M 700.5,1571.5 C 705.894,1570.55 707.561,1572.55 705.5,1577.5C 699.29,1578.97 697.623,1576.97 700.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2eefd",
    d: "M 740.5,1571.5 C 745.006,1570.53 747.172,1572.19 747,1576.5C 745.116,1578.58 742.949,1578.91 740.5,1577.5C 739.181,1575.47 739.181,1573.47 740.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f0fd",
    d: "M 821.5,1571.5 C 827.158,1570.68 828.825,1572.85 826.5,1578C 820.741,1579.14 819.074,1576.97 821.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0ebfd",
    d: "M 902.5,1571.5 C 908.158,1570.68 909.825,1572.85 907.5,1578C 901.244,1578.93 899.577,1576.77 902.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1fd",
    d: "M 942.5,1571.5 C 947.006,1570.53 949.172,1572.19 949,1576.5C 945.507,1579.5 943.007,1578.84 941.5,1574.5C 941.685,1573.42 942.018,1572.42 942.5,1571.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#241f20",
    d: "M 2228.5,1577.5 C 2249.23,1576.07 2261.23,1585.57 2264.5,1606C 2262.67,1623.83 2252.84,1633.66 2235,1635.5C 2221.34,1634.16 2212.01,1627.16 2207,1614.5C 2203.91,1596 2211.07,1583.67 2228.5,1577.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4b1c5",
    d: "M 124.5,1579.5 C 142.98,1578.48 151.48,1587.15 150,1605.5C 143.564,1618.96 133.397,1622.79 119.5,1617C 109.762,1608.66 107.928,1598.82 114,1587.5C 116.94,1583.96 120.44,1581.3 124.5,1579.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edeaf6",
    d: "M 725.5,1588.5 C 723.833,1588.5 722.167,1588.5 720.5,1588.5C 719.489,1586.6 719.322,1584.6 720,1582.5C 726.094,1580.43 727.927,1582.43 725.5,1588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f7fe",
    d: "M 765.5,1588.5 C 765.167,1588.5 764.833,1588.5 764.5,1588.5C 763.5,1588.5 762.5,1588.5 761.5,1588.5C 759.483,1586.78 759.15,1584.78 760.5,1582.5C 766.71,1581.03 768.377,1583.03 765.5,1588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3effd",
    d: "M 805.5,1588.5 C 803.708,1588.63 802.042,1588.3 800.5,1587.5C 799.679,1581.84 801.846,1580.18 807,1582.5C 807.941,1584.99 807.441,1586.99 805.5,1588.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 841.5,1581.5 C 846.006,1580.53 848.172,1582.19 848,1586.5C 844.507,1589.5 842.007,1588.84 840.5,1584.5C 840.685,1583.42 841.018,1582.42 841.5,1581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f0fd",
    d: "M 882.5,1581.5 C 887.894,1580.55 889.561,1582.55 887.5,1587.5C 881.29,1588.97 879.623,1586.97 882.5,1581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f4fe",
    d: "M 922.5,1581.5 C 928.158,1580.68 929.825,1582.85 927.5,1588C 921.741,1589.14 920.074,1586.97 922.5,1581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf9fe",
    d: "M 963.5,1581.5 C 969.016,1581.47 970.349,1583.64 967.5,1588C 961.738,1588.42 960.404,1586.25 963.5,1581.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6b5f7e",
    d: "M 1935.5,1181.5 C 1936.5,1317 1936.83,1452.67 1936.5,1588.5C 1796.83,1588.5 1657.17,1588.5 1517.5,1588.5C 1656.67,1587.5 1796,1587.17 1935.5,1587.5C 1935.5,1452.5 1935.5,1317.5 1935.5,1182.5C 1935.5,1182.17 1935.5,1181.83 1935.5,1181.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ea4776",
    d: "M 2229.5,1586.5 C 2250.3,1586.78 2257.8,1596.78 2252,1616.5C 2244.58,1625.78 2235.42,1627.95 2224.5,1623C 2213.35,1613.01 2212.68,1602.34 2222.5,1591C 2224.9,1589.48 2227.23,1587.98 2229.5,1586.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f40b2",
    d: "M 800.5,1587.5 C 802.042,1588.3 803.708,1588.63 805.5,1588.5C 805.5,1588.83 805.5,1589.17 805.5,1589.5C 791.656,1589.83 777.99,1589.5 764.5,1588.5C 764.833,1588.5 765.167,1588.5 765.5,1588.5C 777.345,1588.83 789.012,1588.49 800.5,1587.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7147ed",
    d: "M 400.5,1595.5 C 578.685,1595.96 756.852,1597.96 935,1601.5C 938.167,1601.83 941.333,1602.17 944.5,1602.5C 948.578,1607.66 952.412,1612.99 956,1618.5C 969.626,1634.4 986.793,1643.56 1007.5,1646C 1154.83,1646.67 1302.17,1646.67 1449.5,1646C 1456.09,1644.53 1462.76,1643.53 1469.5,1643C 1475.5,1640 1481.5,1637 1487.5,1634C 1493.33,1628.17 1499.17,1622.33 1505,1616.5C 1509.64,1609.69 1514.47,1603.03 1519.5,1596.5C 1700.17,1595.5 1880.83,1595.17 2061.5,1595.5C 2061.67,1612.5 2061.5,1629.5 2061,1646.5C 2056.51,1662.78 2052.18,1679.11 2048,1695.5C 2035.5,1708 2023,1720.5 2010.5,1733C 1994.15,1737.34 1977.82,1741.67 1961.5,1746C 1718.17,1746.17 1474.83,1746.33 1231.5,1746.5C 988.167,1746.33 744.833,1746.17 501.5,1746C 484.752,1741.98 468.086,1737.65 451.5,1733C 439.333,1720.83 427.167,1708.67 415,1696.5C 409.956,1679.62 405.289,1662.62 401,1645.5C 400.5,1628.84 400.333,1612.17 400.5,1595.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#231f20",
    d: "M 296.5,1844.5 C 313.809,1846.31 320.309,1855.64 316,1872.5C 308.789,1883.35 299.289,1885.85 287.5,1880C 279.124,1872.6 277.29,1863.77 282,1853.5C 285.768,1848.54 290.601,1845.54 296.5,1844.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c3d85f",
    d: "M 294.5,1854.5 C 302.168,1853.49 306.834,1856.65 308.5,1864C 307.833,1870.34 304.333,1873.5 298,1873.5C 291.142,1872.47 288.142,1868.47 289,1861.5C 290.371,1858.73 292.204,1856.4 294.5,1854.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIls3);
export default __webpack_public_path__ + "static/media/ils3.5605fbb0496675008530517d49ba2bbf.svg";
export { ForwardRef as ReactComponent };